// 自动化码头泊位
export const automation_dock = [
  {
    l: 3,
    "code": "QWE",
    "name": "5S4589",
    "lineName": "地中海",
    "line": "krpus-cnnbo",
    "aTime": "2024.1.8 14:30",
    "lTime": "2024.1.9 16:00",
    "attributes": {
      "OBJECTID": 5,
      "bh": "0108",
      "mc": "108泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 17,
      "xlzbh": "211#-227#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0073822786775762615,
      "shape_Area": 8.731186810405686e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.23236332500005,
            36.012992275000045
          ],
          [
            120.23526787900005,
            36.014819569000053
          ],
          [
            120.23544698800004,
            36.014631644000076
          ],
          [
            120.23254243800011,
            36.012804355000071
          ],
          [
            120.23236332500005,
            36.012992275000045
          ]
        ]
      ]
    },
    //"center": [36.00802080564402, 120.22359641526667]
  },
  {
    l: 23,
    "code": "KQL",
    "name": "5S4010",
    "lineName": "中南美",
    "line": "cnsha-krpus",
    "aTime": "2024.1.8 12:50",
    "lTime": "2024.1.9 12:00",
    //"center": [36.01005123472384, 120.2269567233911],
    "attributes": {
      "OBJECTID": 6,
      "bh": "0108",
      "mc": "107泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "195#-211#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0073360965301385098,
      "shape_Area": 8.6724367656133379e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22947838500011,
            36.011177167000028
          ],
          [
            120.23236332500005,
            36.012992275000045
          ],
          [
            120.23254243800011,
            36.012804355000071
          ],
          [
            120.22965750100002,
            36.010989251000069
          ],
          [
            120.22947838500011,
            36.011177167000028
          ]
        ]
      ]
    }
  },
  {
    l: 43,
    "code": "VOY",
    "name": "5S4399",
    "lineName": "东南亚",
    "line": "cnxin-krpus",
    "aTime": "2024.1.8 6:00",
    "lTime": "2024.1.9 22:00",
    //"center": [36.01175168556612, 120.22970742306478],
    "attributes": {
      "OBJECTID": 7,
      "bh": "0108",
      "mc": "106泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "179#-195#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0073578199453183946,
      "shape_Area": 8.7000736968938644e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22965750100002,
            36.010989251000069
          ],
          [
            120.22676343900002,
            36.009168251000062
          ],
          [
            120.22658432100002,
            36.009356163000064
          ],
          [
            120.22947838500011,
            36.011177167000028
          ],
          [
            120.22965750100002,
            36.010989251000069
          ]
        ]
      ]
    }
  },
  {
    l: 63,
    "code": "HWD",
    "name": "5S4727",
    "lineName": "东南亚",
    "line": "cnypg-cnsha",
    "aTime": "2024.1.8 16:10",
    "lTime": "2024.1.9 1:00",
    //"center": [36.01352682201293, 120.232635360662],
    "attributes": {
      "OBJECTID": 8,
      "bh": "0108",
      "mc": "105泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "163#-179#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.007359586807411867,
      "shape_Area": 8.6998493297321291e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22368711000001,
            36.007539178000059
          ],
          [
            120.2265847000001,
            36.009356401000048
          ],
          [
            120.22676343900002,
            36.009168251000062
          ],
          [
            120.22386585200002,
            36.007351033000077
          ],
          [
            120.22368711000001,
            36.007539178000059
          ]
        ]
      ]
    }
  },
  {
    l: 83,
    "code": "HWD",
    "name": "7S4421",
    "lineName": "东南亚",
    "line": "cnypg-cnsha",
    "aTime": "2024.1.8 16:10",
    "lTime": "2024.1.9 1:00",
    "center": [36.01555742523992, 120.23678751921611],
    "attributes": {
      "OBJECTID": 8,
      "bh": "0108",
      "mc": "105泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "163#-179#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.007359586807411867,
      "shape_Area": 8.6998493297321291e-007
    }
  },
]

// 干散货码头泊位
export const dry_dock = [
  {
    "attributes": {
      "OBJECTID": 48,
      "bh": "0108",
      "mc": "66泊位",
      "dj": "7DWT",
      "ss": -11.5,
      "cd": 200,
      "ssgs_old": "前港公司",
      "xlzs": 6,
      "xlzbh": "294#-299#",
      "kdgs": 11,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.004641357390637979,
      "shape_Area": 5.2443078432356476e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22269497400009,
            36.026158192000025
          ],
          [
            120.22250789800012,
            36.026345174000028
          ],
          [
            120.22250922000001,
            36.026346047000061
          ],
          [
            120.22422862000008,
            36.027481102000024
          ],
          [
            120.22440904400003,
            36.027301186000045
          ],
          [
            120.22269497400009,
            36.026158192000025
          ]
        ]
      ]
    }
  },
  {
    center: [36.02443742995317,120.21989727448985],
    rotation: -0.15,
    "attributes": {
      "OBJECTID": 49,
      "bh": "0108",
      "mc": "68泊位",
      "dj": "7DWT",
      "ss": -11.5,
      "cd": 211,
      "ssgs_old": "前港公司",
      "xlzs": 6,
      "xlzbh": "308#-313#",
      "kdgs": 12,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.0048706641116868996,
      "shape_Area": 5.4891333235605625e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21889207000004,
            36.023951719000024
          ],
          [
            120.21889763900003,
            36.023955492000027
          ],
          [
            120.21925774300007,
            36.024199441000064
          ],
          [
            120.22070413300003,
            36.025154364000059
          ],
          [
            120.22089435600003,
            36.024964301000068
          ],
          [
            120.21934990800003,
            36.023967151000079
          ],
          [
            120.21906695200005,
            36.023776682000062
          ],
          [
            120.21889207000004,
            36.023951719000024
          ]
        ]
      ]
    }
  },
  {
    center: [36.028187849886706,120.22770192363245],
    rotation: 4.3,
    "attributes": {
      "OBJECTID": 50,
      "bh": "0108",
      "mc": "64泊位",
      "dj": "10DWT",
      "ss": -14.1,
      "cd": 265,
      "ssgs_old": "前港公司",
      "xlzs": 9,
      "xlzbh": "1#-9#",
      "kdgs": 15,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0065261645349335541,
      "shape_Area": 7.3597968991870648e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22662601100001,
            36.029063630000053
          ],
          [
            120.22684802200001,
            36.029210177000039
          ],
          [
            120.22697871100002,
            36.02912976500005
          ],
          [
            120.22699485700002,
            36.029147081000076
          ],
          [
            120.22718966100001,
            36.029027220000046
          ],
          [
            120.22717046900004,
            36.029006640000034
          ],
          [
            120.22725904800006,
            36.028952138000079
          ],
          [
            120.2272757180001,
            36.028970014000038
          ],
          [
            120.22747253800003,
            36.028848910000079
          ],
          [
            120.22745351600008,
            36.028828512000075
          ],
          [
            120.22754171100007,
            36.028774246000069
          ],
          [
            120.22755782100012,
            36.028791521000073
          ],
          [
            120.22775410700001,
            36.028670744000067
          ],
          [
            120.22773477800001,
            36.028650018000064
          ],
          [
            120.22781878900003,
            36.028598275000036
          ],
          [
            120.2278207600001,
            36.028597880000063
          ],
          [
            120.22782296900004,
            36.028597871000045
          ],
          [
            120.22782439700006,
            36.028598367000029
          ],
          [
            120.22782570600009,
            36.028599166000049
          ],
          [
            120.22784200500007,
            36.028615062000029
          ],
          [
            120.2280360200001,
            36.028492217000064
          ],
          [
            120.22801724300007,
            36.028472648000047
          ],
          [
            120.2281045950001,
            36.028417340000033
          ],
          [
            120.22812389600006,
            36.028437453000038
          ],
          [
            120.22831770800008,
            36.028314736000027
          ],
          [
            120.22829880800009,
            36.028295041000035
          ],
          [
            120.22838578400001,
            36.028239970000072
          ],
          [
            120.22840495200001,
            36.028259945000059
          ],
          [
            120.22859993200007,
            36.02813648800003
          ],
          [
            120.22858056900009,
            36.028116311000076
          ],
          [
            120.22866815400005,
            36.028060852000067
          ],
          [
            120.22868715000004,
            36.028080648000071
          ],
          [
            120.22888091200002,
            36.027957961000027
          ],
          [
            120.22886207500005,
            36.02793833100003
          ],
          [
            120.22894961800012,
            36.027882901000055
          ],
          [
            120.22896893000006,
            36.027903025000057
          ],
          [
            120.22916160900002,
            36.027781024000035
          ],
          [
            120.22914214200011,
            36.02776073800004
          ],
          [
            120.22918518300003,
            36.027733485000056
          ],
          [
            120.22899387600012,
            36.027559587000042
          ],
          [
            120.22662601100001,
            36.029063630000053
          ]
        ]
      ]
    }
  },
  {
    "code": "QWE",
    "name": "琳达",
    "lineName": "地中海",
    "line": "krpus-cnnbo",
    "aTime": "2024.1.8 2:10",
    "lTime": "2024.1.8 21:30",
    "country": "葡萄牙",
    "product": "超特粉",
    "a": "201350",
    "b": "97000",
    "c": "104350",
    rotation: 0.9,
    "attributes": {
      "OBJECTID": 51,
      "bh": "0108",
      "mc": "76泊位",
      "dj": "25DWT",
      "ss": -21,
      "cd": 383,
      "ssgs_old": "前港公司",
      "xlzs": 16,
      "xlzbh": "0#-16#",
      "kdgs": 14,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0089957532047491053,
      "shape_Area": 1.3572536550095438e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.23105152300002,
            36.029316140000049
          ],
          [
            120.23119379500008,
            36.02962939400004
          ],
          [
            120.23518187000002,
            36.028425552000044
          ],
          [
            120.23505539000007,
            36.028139544000055
          ],
          [
            120.23105152300002,
            36.029316140000049
          ]
        ]
      ]
    }
  },
  {
    "code": "QWE",
    "name": "帕姆",
    "lineName": "巴拿马",
    "line": "krpus-cnnbo",
    "aTime": "2024.1.7 1:30",
    "lTime": "2024.1.9 10:30",
    "country": "巴拿马",
    "product": "铝矾土",
    "a": "179257",
    "b": "133000",
    "c": "46257",
    rotation: -0.47,
    center: [36.03302248483695,120.22713615341233],
    "attributes": {
      "OBJECTID": 52,
      "bh": "0108",
      "mc": "86泊位",
      "dj": "20WT",
      "ss": -14.5,
      "cd": 229,
      "ssgs_old": "前港公司",
      "xlzs": 9,
      "xlzbh": "1#-12#",
      "kdgs": 12,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0042328756355497271,
      "shape_Area": 6.1544272199254837e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.2261389570001,
            36.03156270900007
          ],
          [
            120.22581495400004,
            36.031727905000025
          ],
          [
            120.22657376400002,
            36.032708884000044
          ],
          [
            120.22689359900005,
            36.033122136000031
          ],
          [
            120.2272025420001,
            36.032964423000067
          ],
          [
            120.2261389570001,
            36.03156270900007
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.47,
    center: [36.03486748277289,120.22844948745352],
    "attributes": {
      "OBJECTID": 53,
      "bh": "0108",
      "mc": "87泊位",
      "dj": "20WT",
      "ss": -17.5,
      "cd": 443,
      "ssgs_old": "前港公司",
      "xlzs": 29,
      "xlzbh": "12#-38#",
      "kdgs": 29,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0096007730713331511,
      "shape_Area": 1.5279708081113851e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.22689359900005,
            36.033122136000031
          ],
          [
            120.22961765800005,
            36.036641614000075
          ],
          [
            120.22993108800006,
            36.036481596000044
          ],
          [
            120.2272025420001,
            36.032964423000067
          ],
          [
            120.22689359900005,
            36.033122136000031
          ]
        ]
      ]
    }
  },
  {
    center: [36.02539378679905,120.22150620748465],
    rotation: -0.15,
    "code": "QWE",
    "name": "皮克托",
    "lineName": "巴拿马",
    "line": "krpus-cnnbo",
    "aTime": "2024.1.3 10:00",
    "lTime": "2024.1.8 22:00",
    "country": "利比里亚",
    "product": "铝矾土",
    "a": "200139",
    "b": "166700",
    "c": "33439",
    "attributes": {
      "OBJECTID": 54,
      "bh": "0108",
      "mc": "67泊位",
      "dj": "7DWT",
      "ss": -11.5,
      "cd": 209.5,
      "ssgs_old": "前港公司",
      "xlzs": 8,
      "xlzbh": "300#-307#",
      "kdgs": 17,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.0048552525753951343,
      "shape_Area": 5.6468984906158553e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22269497400009,
            36.026158192000025
          ],
          [
            120.22089435600003,
            36.024964301000068
          ],
          [
            120.22070413300003,
            36.025154364000059
          ],
          [
            120.2207054480001,
            36.025155232000031
          ],
          [
            120.22250789800012,
            36.026345174000028
          ],
          [
            120.22269497400009,
            36.026158192000025
          ]
        ]
      ]
    }
  },
  {
    "code": "QWE",
    "name": "顺鑫航海",
    "lineName": "巴拿马",
    "line": "krpus-cnnbo",
    "aTime": "2024.1.8 5:00",
    "lTime": "2024.1.8 17:30",
    "country": "中国",
    "product": "匹粉",
    "a": "181245",
    "b": "15900",
    "c": "165345",
    center: [36.02671247612028,120.23013961268934],
    rotation: 4.3,
    "attributes": {
      "OBJECTID": 56,
      "bh": "0108",
      "mc": "63泊位",
      "dj": "10DWT",
      "ss": -14.1,
      "cd": 298,
      "ssgs_old": "前港公司",
      "xlzs": 10,
      "xlzbh": "265#-274#",
      "kdgs": 18,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0072680889927425598,
      "shape_Area": 8.3987596973607985e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22919520700009,
            36.027747599000065
          ],
          [
            120.22922413100002,
            36.027708823000069
          ],
          [
            120.22922935300005,
            36.027705518000062
          ],
          [
            120.2292485480001,
            36.027725521000036
          ],
          [
            120.2294430610001,
            36.027602357000035
          ],
          [
            120.22942409600012,
            36.027582595000069
          ],
          [
            120.22951144000001,
            36.027527289000034
          ],
          [
            120.22953041100004,
            36.02754705600006
          ],
          [
            120.2297249070001,
            36.027423901000077
          ],
          [
            120.22970592100012,
            36.027404116000071
          ],
          [
            120.22979262700005,
            36.027349214000026
          ],
          [
            120.22981203500001,
            36.027369437000061
          ],
          [
            120.23000643100011,
            36.027246345000037
          ],
          [
            120.22998685500011,
            36.027225946000044
          ],
          [
            120.23007421300008,
            36.027170630000057
          ],
          [
            120.23009380800011,
            36.027191050000056
          ],
          [
            120.23028672900011,
            36.027068892000045
          ],
          [
            120.23026736000008,
            36.027048708000052
          ],
          [
            120.23035516900006,
            36.026993106000077
          ],
          [
            120.23037423200003,
            36.027012971000033
          ],
          [
            120.23056876100009,
            36.026889794000056
          ],
          [
            120.23054898800001,
            36.02686919000007
          ],
          [
            120.2306365820001,
            36.026813724000078
          ],
          [
            120.23065698000005,
            36.026834979000057
          ],
          [
            120.23085178200006,
            36.026711626000065
          ],
          [
            120.23083284400002,
            36.026691892000031
          ],
          [
            120.23092086700001,
            36.026636154000073
          ],
          [
            120.23094017000005,
            36.026656269000057
          ],
          [
            120.23113372400007,
            36.026533705000077
          ],
          [
            120.23111417400003,
            36.026513334000072
          ],
          [
            120.23120141300001,
            36.026458092000041
          ],
          [
            120.23122093600011,
            36.026478435000058
          ],
          [
            120.23141547300008,
            36.026355249000062
          ],
          [
            120.23139667200007,
            36.02633565800005
          ],
          [
            120.23148394700002,
            36.026280393000036
          ],
          [
            120.23150298300004,
            36.026300230000061
          ],
          [
            120.23169585700009,
            36.026178095000034
          ],
          [
            120.23167735200002,
            36.026158813000052
          ],
          [
            120.23181354300004,
            36.026072571000043
          ],
          [
            120.2318056360001,
            36.026065477000031
          ],
          [
            120.23180151100007,
            36.026075191000075
          ],
          [
            120.23160811500009,
            36.02589832600006
          ],
          [
            120.22899387600012,
            36.027559587000042
          ],
          [
            120.22919520700009,
            36.027747599000065
          ]
        ]
      ]
    }
  },
  {
    center: [36.027811361619115,120.22513266852975],
    rotation: -0.15,
    "attributes": {
      "OBJECTID": 57,
      "bh": "0108",
      "mc": "65泊位",
      "dj": "12DWT",
      "ss": -14.1,
      "cd": 312.5,
      "ssgs_old": "前港公司",
      "xlzs": 12,
      "xlzbh": "282#-293#",
      "kdgs": 14,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.0068217364204525652,
      "shape_Area": 7.0981720870727603e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22440904400003,
            36.027301186000045
          ],
          [
            120.22422862000008,
            36.027481102000024
          ],
          [
            120.22422980900001,
            36.027481886000032
          ],
          [
            120.22598655900003,
            36.028641537000055
          ],
          [
            120.22684802200001,
            36.029210177000039
          ],
          [
            120.22705119200009,
            36.029108286000053
          ],
          [
            120.22440904400003,
            36.027301186000045
          ]
        ]
      ]
    }
  },
]

// 液体码头泊位面
export const liquid_dock = [
  {
    "aTime": "2024.1.8 14:30",
    "lTime": "2024.1.9 16:00",
    "product": "原油",
    rotation: 1.7,
    "attributes": {
      "OBJECTID": 92,
      "bh": "0108",
      "mc": "62泊位",
      "dj": "20WT",
      "ss": -22,
      "cd": 498,
      "ssgs_old": "实华公司",
      "xlzs": 12,
      "xlzbh": "201#-212#",
      "kdgs": 2,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0074598321641118513,
      "shape_Area": 1.8491463958232915e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.24322849900011,
            36.047537011000031
          ],
          [
            120.24264141100002,
            36.047615276000045
          ],
          [
            120.24331683600008,
            36.050680592000049
          ],
          [
            120.2439018120001,
            36.050602471000047
          ],
          [
            120.24322849900011,
            36.047537011000031
          ]
        ]
      ]
    }
  },
  {
    "aTime": "2024.1.8 12:50",
    "lTime": "2024.1.9 12:00",
    "product": "原油",
    rotation: 1.7,
    "attributes": {
      "OBJECTID": 93,
      "bh": "0108",
      "mc": "90泊位",
      "dj": "30WT",
      "ss": -24,
      "cd": 520,
      "ssgs_old": "实华公司",
      "xlzs": 10,
      "xlzbh": "301#-310#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.00742496715994045,
      "shape_Area": 1.8585674071901978e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.24288350100005,
            36.042504785000062
          ],
          [
            120.24228414700008,
            36.042510227000037
          ],
          [
            120.24239382400003,
            36.045629001000066
          ],
          [
            120.24298743400004,
            36.045614139000065
          ],
          [
            120.24288350100005,
            36.042504785000062
          ]
        ]
      ]
    }
  },
  {
    "aTime": "2024.1.8 6:00",
    "lTime": "2024.1.9 22:00",
    "product": "原油",
    rotation: 4.2,
    "attributes": {
      "OBJECTID": 94,
      "bh": "0108",
      "mc": "92泊位",
      "dj": "1WT",
      "ss": -11.1,
      "cd": 213.80000000000001,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "44#-30#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0034941932936184863,
      "shape_Area": 3.476126546165048e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22158770100009,
            36.064803099000073
          ],
          [
            120.22180536600001,
            36.064892056000076
          ],
          [
            120.22267521500009,
            36.063662772000043
          ],
          [
            120.22246402700011,
            36.063562129000047
          ],
          [
            120.22158770100009,
            36.064803099000073
          ]
        ]
      ]
    }
  },
  {
    rotation: 1.1,
    "attributes": {
      "OBJECTID": 95,
      "bh": "0108",
      "mc": "91泊位",
      "dj": "5WT",
      "ss": -11.1,
      "cd": 213.80000000000001,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "43#-29#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0034664684141540933,
      "shape_Area": 3.2983035061331441e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.2224783910001,
            36.065213437000068
          ],
          [
            120.22336143100006,
            36.06398054400006
          ],
          [
            120.22314839900002,
            36.063884194000025
          ],
          [
            120.22228974500001,
            36.065122128000041
          ],
          [
            120.2224783910001,
            36.065213437000068
          ]
        ]
      ]
    }
  },
  {
    rotation: 1,
    "attributes": {
      "OBJECTID": 96,
      "bh": "0108",
      "mc": "89泊位",
      "dj": "15WT",
      "ss": -16.899999999999999,
      "cd": 388,
      "ssgs_old": "实华公司",
      "xlzs": 10,
      "xlzbh": "28#-19#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0060950458367622501,
      "shape_Area": 1.2628014435151602e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.21469658300009,
            36.070653667000045
          ],
          [
            120.21518324400006,
            36.070850291000056
          ],
          [
            120.21664497400002,
            36.068785038000044
          ],
          [
            120.21618483600002,
            36.068593451000027
          ],
          [
            120.21469658300009,
            36.070653667000045
          ]
        ]
      ]
    }
  },
  {
    rotation: 1,
    "aTime": "2024.1.8 16:10",
    "lTime": "2024.1.9 1:00",
    "product": "原油",
    "attributes": {
      "OBJECTID": 97,
      "bh": "0108",
      "mc": "84泊位",
      "dj": "7.5WT",
      "ss": -14.199999999999999,
      "cd": 319,
      "ssgs_old": "实华公司",
      "xlzs": 15,
      "xlzbh": "18#-4#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0051787265947773184,
      "shape_Area": 8.5111298422027068e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21833844200012,
            36.065893593000055
          ],
          [
            120.21799560600004,
            36.065724178000039
          ],
          [
            120.21671093500004,
            36.067509130000076
          ],
          [
            120.21707279800012,
            36.067686109000078
          ],
          [
            120.21833844200012,
            36.065893593000055
          ]
        ]
      ]
    }
  },
  {
    "aTime": "2024.1.8 5:00",
    "lTime": "2024.1.8 17:30",
    "product": "原油",
    rotation: 1,
    "attributes": {
      "OBJECTID": 98,
      "bh": "0108",
      "mc": "88泊位",
      "dj": "1.5WT",
      "ss": -9.8000000000000007,
      "cd": 201.90000000000001,
      "ssgs_old": "实华公司",
      "xlzs": 3,
      "xlzbh": "3#-1#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0027823293173270731,
      "shape_Area": 2.4776648492349313e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21911131800005,
            36.064171070000043
          ],
          [
            120.21842987000002,
            36.065134543000056
          ],
          [
            120.21862926500012,
            36.06522093600006
          ],
          [
            120.21930316200007,
            36.064260559000047
          ],
          [
            120.21911131800005,
            36.064171070000043
          ]
        ]
      ]
    }
  },
  {
    center: [36.06819544967021, 120.22387027221822],
    rotation: 1.1,
    "attributes": {
      "OBJECTID": 99,
      "bh": "0108",
      "mc": "60泊位",
      "dj": "2WT",
      "ss": -10.5,
      "cd": 314,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "220#-227#",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0040081009867238655,
      "shape_Area": 4.509008313751962e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22388512700002,
            36.068841515000031
          ],
          [
            120.22411830200008,
            36.068954287000054
          ],
          [
            120.22512693600004,
            36.067536784000026
          ],
          [
            120.22489093500008,
            36.067416305000052
          ],
          [
            120.22388512700002,
            36.068841515000031
          ]
        ]
      ]
    }
  },
  {
    rotation: 4.2,
    "attributes": {
      "OBJECTID": 100,
      "bh": "0108",
      "mc": "61泊位",
      "dj": "5WT",
      "ss": -12.5,
      "cd": 314,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "228#-233#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0051725857829987027,
      "shape_Area": 7.5098468276737755e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22579377400007,
            36.067572077000079
          ],
          [
            120.22548763800012,
            36.067425046000039
          ],
          [
            120.22419103600009,
            36.069260082000028
          ],
          [
            120.22449536400006,
            36.069407237000064
          ],
          [
            120.22579377400007,
            36.067572077000079
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 101,
      "bh": "0108",
      "mc": "93泊位",
      "dj": "3000T",
      "ss": -5.5,
      "cd": 198,
      "ssgs_old": "实华公司",
      "xlzs": 9,
      "xlzbh": "234#-242#",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0038769345417660568,
      "shape_Area": 3.4716414108181436e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.2284225840001,
            36.063157699000044
          ],
          [
            120.22671831300011,
            36.063486609000051
          ],
          [
            120.22676303600008,
            36.063680465000061
          ],
          [
            120.22847310700001,
            36.063352224000027
          ],
          [
            120.2284225840001,
            36.063157699000044
          ]
        ]
      ]
    }
  },
  {
    rotation: -1.2,
    "attributes": {
      "OBJECTID": 103,
      "bh": "0108",
      "mc": "HX1",
      "dj": "1WT",
      "ss": -9.4000000000000004,
      "cd": 167,
      "ssgs_old": "红星物流公司",
      "xlzs": 0,
      "xlzbh": " ",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "红星物流",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0010617513751461566,
      "shape_Area": 4.7713291911422137e-008
    },
    "geometry": {
      "rings": [
        [
          [
            120.21195687700003,
            36.065055200000074
          ],
          [
            120.21184465700003,
            36.065087496000046
          ],
          [
            120.21201424700007,
            36.065464899000062
          ],
          [
            120.21212614700005,
            36.06543436000004
          ],
          [
            120.21195687700003,
            36.065055200000074
          ]
        ]
      ]
    }
  },
  {
    rotation: -1.2,
    "attributes": {
      "OBJECTID": 104,
      "bh": "0108",
      "mc": "HX2",
      "dj": "5WT",
      "ss": -14,
      "cd": 280,
      "ssgs_old": "红星物流公司",
      "xlzs": 0,
      "xlzbh": " ",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "红星物流",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0019428211033303343,
      "shape_Area": 1.1220175645024779e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21274764000009,
            36.066797153000039
          ],
          [
            120.21261499400009,
            36.066832570000031
          ],
          [
            120.21296155400012,
            36.067593044000034
          ],
          [
            120.21309184300003,
            36.06755770400008
          ],
          [
            120.21274764000009,
            36.066797153000039
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 1,
      "bh": "0108",
      "mc": "公务船泊位",
      "dj": " ",
      "ss": 0,
      "cd": 1058.8,
      "ssgs_old": " ",
      "xlzs": 103,
      "xlzbh": "无编号",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.020336267200113674,
      "shape_Area": 3.732747774540015e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.76693140800012,
            35.581170807000035
          ],
          [
            119.76705916700007,
            35.580931207000049
          ],
          [
            119.76676953900005,
            35.580774923000035
          ],
          [
            119.76375697600008,
            35.580767841000068
          ],
          [
            119.76375127200004,
            35.582714992000035
          ],
          [
            119.76592940700004,
            35.58390918200007
          ],
          [
            119.7677048380001,
            35.581747973000063
          ],
          [
            119.7678828280001,
            35.581532036000056
          ],
          [
            119.76747866500011,
            35.581298332000074
          ],
          [
            119.76574339600006,
            35.583485219000067
          ],
          [
            119.76426362000007,
            35.582566617000055
          ],
          [
            119.76423885100007,
            35.581058259000031
          ],
          [
            119.76663975700001,
            35.581080817000043
          ],
          [
            119.76693140800012,
            35.581170807000035
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.5,
    "attributes": {
      "OBJECTID": 2,
      "bh": "0108",
      "mc": "D24泊位",
      "dj": "5WT",
      "ss": -14.300000000000001,
      "cd": 233,
      "ssgs_old": "液体化工码头有限公司\r\n",
      "xlzs": 15,
      "xlzbh": "01#-15#",
      "kdgs": 31,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "液体化工码头有限公司\r\n",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0060349622639239778,
      "shape_Area": 1.0852019330973793e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.77457122600003,
            35.584738057000038
          ],
          [
            119.77232896500004,
            35.583476309000048
          ],
          [
            119.77204172100005,
            35.583810819000064
          ],
          [
            119.7743322770001,
            35.585068696000064
          ],
          [
            119.77457122600003,
            35.584738057000038
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 3,
      "bh": "0108",
      "mc": "公用泊位",
      "dj": " ",
      "ss": 0,
      "cd": 1027.5,
      "ssgs_old": " ",
      "xlzs": 59,
      "xlzbh": "9#-65#",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.020891846639747143,
      "shape_Area": 4.594946582851676e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.78215358300008,
            35.578174082000032
          ],
          [
            119.7758414650001,
            35.585897490000036
          ],
          [
            119.77624084400009,
            35.58611680000007
          ],
          [
            119.78257593800004,
            35.578405171000043
          ],
          [
            119.78215358300008,
            35.578174082000032
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 4,
      "bh": "0108",
      "mc": "公用泊位",
      "dj": " ",
      "ss": 0,
      "cd": 690.79999999999995,
      "ssgs_old": " ",
      "xlzs": 8,
      "xlzbh": "1#-8#",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.015262012731633832,
      "shape_Area": 2.7411598545745488e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.77621906700006,
            35.574926969000046
          ],
          [
            119.77597619400001,
            35.575221547000069
          ],
          [
            119.78232946900005,
            35.578705228000047
          ],
          [
            119.78257593800004,
            35.578405171000043
          ],
          [
            119.77621906700006,
            35.574926969000046
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 5,
      "bh": "0108",
      "mc": "108泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 17,
      "xlzbh": "211#-227#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0073822786775762615,
      "shape_Area": 8.731186810405686e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.23236332500005,
            36.012992275000045
          ],
          [
            120.23526787900005,
            36.014819569000053
          ],
          [
            120.23544698800004,
            36.014631644000076
          ],
          [
            120.23254243800011,
            36.012804355000071
          ],
          [
            120.23236332500005,
            36.012992275000045
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 6,
      "bh": "0108",
      "mc": "107泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "195#-211#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0073360965301385098,
      "shape_Area": 8.6724367656133379e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22947838500011,
            36.011177167000028
          ],
          [
            120.23236332500005,
            36.012992275000045
          ],
          [
            120.23254243800011,
            36.012804355000071
          ],
          [
            120.22965750100002,
            36.010989251000069
          ],
          [
            120.22947838500011,
            36.011177167000028
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 7,
      "bh": "0108",
      "mc": "106泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "179#-195#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0073578199453183946,
      "shape_Area": 8.7000736968938644e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22965750100002,
            36.010989251000069
          ],
          [
            120.22676343900002,
            36.009168251000062
          ],
          [
            120.22658432100002,
            36.009356163000064
          ],
          [
            120.22947838500011,
            36.011177167000028
          ],
          [
            120.22965750100002,
            36.010989251000069
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 8,
      "bh": "0108",
      "mc": "105泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTN",
      "xlzs": 16,
      "xlzbh": "163#-179#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTN",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.007359586807411867,
      "shape_Area": 8.6998493297321291e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22368711000001,
            36.007539178000059
          ],
          [
            120.2265847000001,
            36.009356401000048
          ],
          [
            120.22676343900002,
            36.009168251000062
          ],
          [
            120.22386585200002,
            36.007351033000077
          ],
          [
            120.22368711000001,
            36.007539178000059
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 9,
      "bh": "0108",
      "mc": "104泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTU",
      "xlzs": 16,
      "xlzbh": "147#-162#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0077774476704222939,
      "shape_Area": 9.23126792475683e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22079133800003,
            36.005422687000078
          ],
          [
            120.22061259300006,
            36.005610827000055
          ],
          [
            120.22368711000001,
            36.007539178000059
          ],
          [
            120.22386585200002,
            36.007351033000077
          ],
          [
            120.22079133800003,
            36.005422687000078
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 10,
      "bh": "0108",
      "mc": "103泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTU",
      "xlzs": 17,
      "xlzbh": "129#-147#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0068960678681329064,
      "shape_Area": 8.1157647400132729e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21809652200011,
            36.003718785000046
          ],
          [
            120.21791687900009,
            36.003906359000041
          ],
          [
            120.22061169600011,
            36.00561026500003
          ],
          [
            120.22079133800003,
            36.005422687000078
          ],
          [
            120.21809652200011,
            36.003718785000046
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 11,
      "bh": "0108",
      "mc": "102泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTU",
      "xlzs": 16,
      "xlzbh": "114#-129#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0075306961695497943,
      "shape_Area": 8.9241778713065691e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21513436900011,
            36.001843984000061
          ],
          [
            120.21495462100006,
            36.002031490000036
          ],
          [
            120.21791677600004,
            36.003906295000036
          ],
          [
            120.21809652200011,
            36.003718785000046
          ],
          [
            120.21513436900011,
            36.001843984000061
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 12,
      "bh": "0108",
      "mc": "101泊位",
      "dj": "20WT",
      "ss": -20,
      "cd": 330,
      "ssgs_old": "QQCTU",
      "xlzs": 17,
      "xlzbh": "97#-114#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0072314916210191506,
      "shape_Area": 8.5398333772303263e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21229458900007,
            36.000055343000042
          ],
          [
            120.21211539000001,
            36.000243194000063
          ],
          [
            120.21495517300002,
            36.002031840000029
          ],
          [
            120.21513436900011,
            36.001843984000061
          ],
          [
            120.21229458900007,
            36.000055343000042
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 13,
      "bh": "0108",
      "mc": "U1泊位",
      "dj": "15WT",
      "ss": -17,
      "cd": 397,
      "ssgs_old": "QQCTU",
      "xlzs": 21,
      "xlzbh": "76#-96#",
      "kdgs": 20,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0087281903127392549,
      "shape_Area": 1.0443809949710691e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.20882142000005,
            35.997868132000065
          ],
          [
            120.20864224800005,
            35.998055997000051
          ],
          [
            120.21211541900004,
            36.000243213000033
          ],
          [
            120.21229458900007,
            36.000055343000042
          ],
          [
            120.20882142000005,
            35.997868132000065
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 14,
      "bh": "0108",
      "mc": "U2泊位",
      "dj": "15WT",
      "ss": -17,
      "cd": 397,
      "ssgs_old": "QQCTU",
      "xlzs": 21,
      "xlzbh": "55#-76#",
      "kdgs": 20,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0085570304290264777,
      "shape_Area": 9.9541805962798536e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.20534101600003,
            35.995706301000041
          ],
          [
            120.2053060290001,
            35.995969064000064
          ],
          [
            120.20864224800005,
            35.998055997000051
          ],
          [
            120.20882142000005,
            35.997868132000065
          ],
          [
            120.20534101600003,
            35.995706301000041
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 15,
      "bh": "0108",
      "mc": "U9泊位",
      "dj": "3WT",
      "ss": -13.5,
      "cd": 250,
      "ssgs_old": "西联公司",
      "xlzs": 11,
      "xlzbh": "32#-43#",
      "kdgs": 17,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联南港区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0055102077253002864,
      "shape_Area": 6.2500008532017966e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.18992306500002,
            36.000548051000067
          ],
          [
            120.19012922400009,
            36.000397288000045
          ],
          [
            120.18845359500006,
            35.998884212000064
          ],
          [
            120.18827376900003,
            35.998721827000054
          ],
          [
            120.18806795600005,
            35.998872801000061
          ],
          [
            120.18992306500002,
            36.000548051000067
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 16,
      "bh": "0108",
      "mc": "D6泊位",
      "dj": "5WT",
      "ss": -17.5,
      "cd": 304,
      "ssgs_old": "董分",
      "xlzs": 13,
      "xlzbh": "北2码头1#-北2码头13#",
      "kdgs": 16,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0079144142174645063,
      "shape_Area": 1.5475506477567384e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.78802368700008,
            35.594998218000057
          ],
          [
            119.78493167500005,
            35.593321382000056
          ],
          [
            119.78465162800001,
            35.593661817000054
          ],
          [
            119.78771477500004,
            35.595342236000079
          ],
          [
            119.78802368700008,
            35.594998218000057
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 17,
      "bh": "0108",
      "mc": "华能2号泊位",
      "dj": "3.5WT",
      "ss": -11.699999999999999,
      "cd": 237.5,
      "ssgs_old": "董分",
      "xlzs": 15,
      "xlzbh": "华能1#-华能15#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0063074723252102647,
      "shape_Area": 1.0998539957746456e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.79271846800009,
            35.601115587000038
          ],
          [
            119.7909815380001,
            35.603229060000047
          ],
          [
            119.79132388000005,
            35.603416361000029
          ],
          [
            119.79309930300008,
            35.601312515000075
          ],
          [
            119.79271846800009,
            35.601115587000038
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 18,
      "bh": "0108",
      "mc": "大唐集装箱泊位1",
      "dj": "3.5WT",
      "ss": -17.5,
      "cd": 230,
      "ssgs_old": "董分",
      "xlzs": 9,
      "xlzbh": "北三19#-28#",
      "kdgs": 10,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0048942911191996088,
      "shape_Area": 8.1083241447409047e-007
    },
    "geometry": {
      "rings": [
        [
          [
            119.7972215640001,
            35.606180904000041
          ],
          [
            119.79541683100001,
            35.605214695000029
          ],
          [
            119.79516128800003,
            35.605515754000066
          ],
          [
            119.79694296700006,
            35.606494511000051
          ],
          [
            119.7972215640001,
            35.606180904000041
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 19,
      "bh": "0108",
      "mc": "D7泊位",
      "dj": "5WT",
      "ss": -17.5,
      "cd": 248,
      "ssgs_old": "董分",
      "xlzs": 10,
      "xlzbh": "北2码头13#-北2码头23#",
      "kdgs": 13,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0074309555386552701,
      "shape_Area": 1.4532773142641665e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.78802368700008,
            35.594998218000057
          ],
          [
            119.78771477500004,
            35.595342236000079
          ],
          [
            119.79057358700004,
            35.596910394000076
          ],
          [
            119.79087352500005,
            35.596571120000078
          ],
          [
            119.78802368700008,
            35.594998218000057
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 20,
      "bh": "0108",
      "mc": "华能1号泊位",
      "dj": "5WT",
      "ss": -13.5,
      "cd": 310,
      "ssgs_old": "董分",
      "xlzs": 15,
      "xlzbh": "华能15#-华能30#",
      "kdgs": 15,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0062632883007880807,
      "shape_Area": 1.1281023779530178e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.79309930300008,
            35.601312515000075
          ],
          [
            119.79480824500001,
            35.599226960000067
          ],
          [
            119.79459548600005,
            35.599103774000071
          ],
          [
            119.79444570200008,
            35.599015963000056
          ],
          [
            119.79271846800009,
            35.601115587000038
          ],
          [
            119.79309930300008,
            35.601312515000075
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.5,
    "attributes": {
      "OBJECTID": 21,
      "bh": "0108",
      "mc": "D12泊位",
      "dj": "30WT",
      "ss": -27,
      "cd": 450,
      "ssgs_old": "实华公司",
      "xlzs": 10,
      "xlzbh": "01#-10#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "EAM2021007079",
      "ssgs": "实华公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.008080163411979896,
      "shape_Area": 2.0398815763189509e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.77937103500005,
            35.570606086000055
          ],
          [
            119.78241681000009,
            35.572197438000046
          ],
          [
            119.78278886700002,
            35.571722085000033
          ],
          [
            119.77974310100001,
            35.57013074200006
          ],
          [
            119.77937103500005,
            35.570606086000055
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 22,
      "bh": "0108",
      "mc": "D23泊位",
      "dj": "10WT",
      "ss": -16.699999999999999,
      "cd": 304,
      "ssgs_old": "摩科瑞",
      "xlzs": 10,
      "xlzbh": "01#-10#",
      "kdgs": 24,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "摩科瑞",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0076801934741413608,
      "shape_Area": 1.3107190695625892e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.77042749000009,
            35.571739579000052
          ],
          [
            119.77018181400001,
            35.572037531000035
          ],
          [
            119.77320772200005,
            35.573702906000051
          ],
          [
            119.77345339200008,
            35.573404949000064
          ],
          [
            119.77042749000009,
            35.571739579000052
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 23,
      "bh": "0108",
      "mc": "B3F泊位",
      "dj": "7WT",
      "ss": -15.5,
      "cd": 147,
      "ssgs_old": "董分",
      "xlzs": 13,
      "xlzbh": "北三1#-13#",
      "kdgs": 11,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0055668431308259275,
      "shape_Area": 9.430756635259967e-007
    },
    "geometry": {
      "rings": [
        [
          [
            119.79331663400001,
            35.604076603000067
          ],
          [
            119.79124821700009,
            35.602903204000029
          ],
          [
            119.7909815380001,
            35.603229060000047
          ],
          [
            119.79307275500003,
            35.604373176000024
          ],
          [
            119.79331663400001,
            35.604076603000067
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 24,
      "bh": "0108",
      "mc": "大唐集装箱泊位2",
      "dj": "5WT",
      "ss": -17.5,
      "cd": 245,
      "ssgs_old": "董分",
      "xlzs": 10,
      "xlzbh": "北三28#-38#",
      "kdgs": 10,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0063737038275850418,
      "shape_Area": 1.0819958585900093e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.79694296700006,
            35.606494511000051
          ],
          [
            119.79940716700003,
            35.607844494000062
          ],
          [
            119.79963375000011,
            35.607552511000051
          ],
          [
            119.7972215640001,
            35.606180904000041
          ],
          [
            119.79694296700006,
            35.606494511000051
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.5,
    "attributes": {
      "OBJECTID": 25,
      "bh": "0108",
      "mc": "HW1泊位",
      "dj": "3DWT",
      "ss": -12.5,
      "cd": 243.80000000000001,
      "ssgs_old": "海湾港务",
      "xlzs": 11,
      "xlzbh": "HW-XCZ-01-HW-XCZ-11",
      "kdgs": 23,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "海湾港务",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.005797991440317736,
      "shape_Area": 1.2307318048789202e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.7699622450001,
            35.582671445000074
          ],
          [
            119.77030716100001,
            35.582296925000037
          ],
          [
            119.76826588100005,
            35.581120918000067
          ],
          [
            119.7678828280001,
            35.581532036000056
          ],
          [
            119.7699622450001,
            35.582671445000074
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.5,
    "attributes": {
      "OBJECTID": 26,
      "bh": "0108",
      "mc": "D13泊位",
      "dj": "10DWT",
      "ss": -16.5,
      "cd": 302,
      "ssgs_old": "实华公司",
      "xlzs": 17,
      "xlzbh": "1#-17#",
      "kdgs": 22,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0070824273894641385,
      "shape_Area": 1.1911673599521665e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.77320772200005,
            35.573702906000051
          ],
          [
            119.77597619400001,
            35.575221547000069
          ],
          [
            119.77621906700006,
            35.574926969000046
          ],
          [
            119.77345339200008,
            35.573404949000064
          ],
          [
            119.77320772200005,
            35.573702906000051
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 27,
      "bh": "0108",
      "mc": "B3A泊位",
      "dj": "7WT",
      "ss": -17.5,
      "cd": 297.58100000000002,
      "ssgs_old": "董分",
      "xlzs": 6,
      "xlzbh": "北三13#-19#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董家口分公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0055482422781953514,
      "shape_Area": 9.1058396499945787e-007
    },
    "geometry": {
      "rings": [
        [
          [
            119.79331663400001,
            35.604076603000067
          ],
          [
            119.79307275500003,
            35.604373176000024
          ],
          [
            119.79516128800003,
            35.605515754000066
          ],
          [
            119.79541683100001,
            35.605214695000029
          ],
          [
            119.79331663400001,
            35.604076603000067
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 28,
      "bh": "0108",
      "mc": "U6泊位",
      "dj": "3WT",
      "ss": -13.5,
      "cd": 214.5,
      "ssgs_old": "西联公司",
      "xlzs": 11,
      "xlzbh": "1#-11#",
      "kdgs": 9,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联南港区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0049116731867216105,
      "shape_Area": 5.4155853823214725e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19192176200011,
            35.996052340000062
          ],
          [
            120.1921082340001,
            35.996221350000042
          ],
          [
            120.19380587300009,
            35.994976909000059
          ],
          [
            120.19378895700004,
            35.994740493000052
          ],
          [
            120.19375599600005,
            35.994709816000068
          ],
          [
            120.19192176200011,
            35.996052340000062
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 29,
      "bh": "0108",
      "mc": "U8泊位",
      "dj": "4WT",
      "ss": -13.5,
      "cd": 261.30000000000001,
      "ssgs_old": "西联公司",
      "xlzs": 12,
      "xlzbh": "21#-32#",
      "kdgs": 15,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联南港区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.005105130467814363,
      "shape_Area": 5.5268844876597755e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19031902800009,
            35.997524995000049
          ],
          [
            120.19013641100003,
            35.99735901400004
          ],
          [
            120.18827376900003,
            35.998721827000054
          ],
          [
            120.18845359500006,
            35.998884212000064
          ],
          [
            120.19031902800009,
            35.997524995000049
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 30,
      "bh": "0108",
      "mc": "U7泊位",
      "dj": "3WT",
      "ss": -13.5,
      "cd": 214.5,
      "ssgs_old": "西联公司",
      "xlzs": 11,
      "xlzbh": "11#-21#",
      "kdgs": 9,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联南港区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.004924643229606394,
      "shape_Area": 5.402211133794576e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19013641100003,
            35.99735901400004
          ],
          [
            120.19031902800009,
            35.997524995000049
          ],
          [
            120.1921082340001,
            35.996221350000042
          ],
          [
            120.19192176200011,
            35.996052340000062
          ],
          [
            120.19013641100003,
            35.99735901400004
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 31,
      "bh": "0108",
      "mc": "74号泊位",
      "dj": "1.5WT",
      "ss": -10.699999999999999,
      "cd": 192,
      "ssgs_old": "西联公司",
      "xlzs": 9,
      "xlzbh": "373#-381#",
      "kdgs": 8,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0037447810883831298,
      "shape_Area": 4.0159673701964975e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21568265900009,
            36.017100870000036
          ],
          [
            120.21692423700006,
            36.016061864000051
          ],
          [
            120.21672525300005,
            36.015904927000065
          ],
          [
            120.2154836740001,
            36.016943931000071
          ],
          [
            120.21568265900009,
            36.017100870000036
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 32,
      "bh": "0108",
      "mc": "72号泊位",
      "dj": "1WT",
      "ss": -10.699999999999999,
      "cd": 198,
      "ssgs_old": "西联公司",
      "xlzs": 11,
      "xlzbh": "353#363#",
      "kdgs": 11,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0047263473389391299,
      "shape_Area": 5.2334426544242552e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21413401700011,
            36.018396787000029
          ],
          [
            120.21393503100001,
            36.01823984400005
          ],
          [
            120.21238338900002,
            36.01953820600005
          ],
          [
            120.21231701600004,
            36.01959374200004
          ],
          [
            120.21251600100004,
            36.019750688000045
          ],
          [
            120.21258237400002,
            36.019695151000064
          ],
          [
            120.21413401700011,
            36.018396787000029
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 33,
      "bh": "0108",
      "mc": "73号泊位",
      "dj": "1.5WT",
      "ss": -10.699999999999999,
      "cd": 192,
      "ssgs_old": "西联公司",
      "xlzs": 11,
      "xlzbh": "363#-373#",
      "kdgs": 10,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0045455136610052273,
      "shape_Area": 5.0091379684806125e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21413401700011,
            36.018396787000029
          ],
          [
            120.21568265900009,
            36.017100870000036
          ],
          [
            120.2154836740001,
            36.016943931000071
          ],
          [
            120.21393503100001,
            36.01823984400005
          ],
          [
            120.21413401700011,
            36.018396787000029
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 34,
      "bh": "0108",
      "mc": "85号B泊位",
      "dj": "5000T",
      "ss": -7.7999999999999998,
      "cd": 155.80000000000001,
      "ssgs_old": "西联公司",
      "xlzs": 10,
      "xlzbh": "532#-541#",
      "kdgs": 8,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联南港区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0034445086442412734,
      "shape_Area": 3.6657819491590605e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.1936829660001,
            35.999669080000047
          ],
          [
            120.19345813500001,
            35.999548035000032
          ],
          [
            120.19253224000011,
            36.00068694600003
          ],
          [
            120.1927551660001,
            36.000806966000027
          ],
          [
            120.1936829660001,
            35.999669080000047
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 35,
      "bh": "0108",
      "mc": "85号A泊位",
      "dj": "1WT",
      "ss": -9,
      "cd": 162.19999999999999,
      "ssgs_old": "西联公司",
      "xlzs": 9,
      "xlzbh": "523#-531#",
      "kdgs": 7,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "西联南港区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0037123227388349213,
      "shape_Area": 3.7802014400506598e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19432081500008,
            35.999986036000053
          ],
          [
            120.19562735700003,
            35.99903157600005
          ],
          [
            120.19544850800003,
            35.998869918000025
          ],
          [
            120.19414561700012,
            35.999827676000052
          ],
          [
            120.19432081500008,
            35.999986036000053
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 36,
      "bh": "0108",
      "mc": "83号泊位",
      "dj": "7WT",
      "ss": -17.5,
      "cd": 327,
      "ssgs_old": "QQCT",
      "xlzs": 16,
      "xlzbh": "507#-522#",
      "kdgs": 16,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0070531334344607951,
      "shape_Area": 8.1777435768748124e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19616058000008,
            35.999162297000055
          ],
          [
            120.19584709000003,
            35.998879192000061
          ],
          [
            120.19564097800003,
            35.999029896000025
          ],
          [
            120.19595446700009,
            35.999313002000065
          ],
          [
            120.19806878700001,
            36.001222319000078
          ],
          [
            120.1982749010001,
            36.001071610000054
          ],
          [
            120.19616058000008,
            35.999162297000055
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 37,
      "bh": "0108",
      "mc": "82号泊位",
      "dj": "20WT",
      "ss": -17.5,
      "cd": 348,
      "ssgs_old": "QQCT",
      "xlzs": 18,
      "xlzbh": "489#-506#",
      "kdgs": 18,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0074679541987394456,
      "shape_Area": 8.6962856714685431e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19829135400005,
            36.001423297000031
          ],
          [
            120.20065062200001,
            36.003553643000032
          ],
          [
            120.20085673700009,
            36.00340293000005
          ],
          [
            120.19849746700004,
            36.001272588000063
          ],
          [
            120.1982749010001,
            36.001071610000054
          ],
          [
            120.19806878700001,
            36.001222319000078
          ],
          [
            120.19829135400005,
            36.001423297000031
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 38,
      "bh": "0108",
      "mc": "80号泊位",
      "dj": "15WT",
      "ss": -17,
      "cd": 312,
      "ssgs_old": "QQCT",
      "xlzs": 16,
      "xlzbh": "456#-471#",
      "kdgs": 16,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0067485097259866117,
      "shape_Area": 7.7971260374036122e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.20343294300005,
            36.006065783000054
          ],
          [
            120.20554762300003,
            36.007974964000027
          ],
          [
            120.20575374000009,
            36.007824242000027
          ],
          [
            120.20363905800002,
            36.005915064000078
          ],
          [
            120.20343872500007,
            36.00573419300008
          ],
          [
            120.20323260900011,
            36.005884911000066
          ],
          [
            120.20343294300005,
            36.006065783000054
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 39,
      "bh": "0108",
      "mc": "78号泊位",
      "dj": "10DWT",
      "ss": -16,
      "cd": 315,
      "ssgs_old": "QQCT",
      "xlzs": 16,
      "xlzbh": "422#-437#",
      "kdgs": 16,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0068087708018057854,
      "shape_Area": 7.8725495343834922e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.20856771400008,
            36.010701343000051
          ],
          [
            120.21068264200005,
            36.012610432000031
          ],
          [
            120.21088876100009,
            36.012459701000068
          ],
          [
            120.20877383200002,
            36.010550616000046
          ],
          [
            120.20855121300008,
            36.010349658000052
          ],
          [
            120.20834509500003,
            36.010500384000068
          ],
          [
            120.20856771400008,
            36.010701343000051
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 40,
      "bh": "0108",
      "mc": "77号泊位",
      "dj": "10DWT",
      "ss": -16,
      "cd": 384.5,
      "ssgs_old": "QQCT",
      "xlzs": 20,
      "xlzbh": "402#-421#",
      "kdgs": 19,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0081749862300122909,
      "shape_Area": 9.5384994309294205e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21373284000003,
            36.015029990000073
          ],
          [
            120.2135434270001,
            36.014863278000064
          ],
          [
            120.21351691100006,
            36.014838788000077
          ],
          [
            120.21344465900006,
            36.014771856000038
          ],
          [
            120.21322643500002,
            36.014569698000059
          ],
          [
            120.21111139200002,
            36.012660655000047
          ],
          [
            120.21088876100009,
            36.012459701000068
          ],
          [
            120.21068264300004,
            36.012610432000031
          ],
          [
            120.21090527400008,
            36.012811386000067
          ],
          [
            120.21302031400012,
            36.014720433000036
          ],
          [
            120.21334138000009,
            36.015010217000054
          ],
          [
            120.21334873600006,
            36.01500483600006
          ],
          [
            120.21336111300002,
            36.015016007000042
          ],
          [
            120.21355901600009,
            36.01517384400006
          ],
          [
            120.21373284000003,
            36.015029990000073
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 41,
      "bh": "0108",
      "mc": "75号泊位",
      "dj": "1.5DWT",
      "ss": -9,
      "cd": 260,
      "ssgs_old": "QQCT",
      "xlzs": 13,
      "xlzbh": "381#-394#",
      "kdgs": 12,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0057852113490232402,
      "shape_Area": 6.619098378335419e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21471676500005,
            36.014215686000057
          ],
          [
            120.2167949520001,
            36.015839180000057
          ],
          [
            120.21698717000004,
            36.015676773000052
          ],
          [
            120.21491628500007,
            36.01404711400005
          ],
          [
            120.21471676500005,
            36.014215686000057
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 42,
      "bh": "0108",
      "mc": "U3泊位",
      "dj": "10WT",
      "ss": -17,
      "cd": 421,
      "ssgs_old": "QQCTU",
      "xlzs": 21,
      "xlzbh": "34#-55#",
      "kdgs": 19,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0093384235073882115,
      "shape_Area": 1.1615785996528375e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.20094934600002,
            35.995327459000066
          ],
          [
            120.20091979200004,
            35.995588431000044
          ],
          [
            120.2053060290001,
            35.995969064000064
          ],
          [
            120.20534101600003,
            35.995706301000041
          ],
          [
            120.20094934600002,
            35.995327459000066
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 43,
      "bh": "0108",
      "mc": "U4泊位",
      "dj": "10WT",
      "ss": -14.1,
      "cd": 314,
      "ssgs_old": "QQCTU",
      "xlzs": 16,
      "xlzbh": "18#-34#",
      "kdgs": 16,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.007749198978162463,
      "shape_Area": 9.3964554227405836e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19734876400003,
            35.995018928000036
          ],
          [
            120.19731817500008,
            35.995274625000036
          ],
          [
            120.20091979200004,
            35.995588431000044
          ],
          [
            120.20094934600002,
            35.995327459000066
          ],
          [
            120.19734876400003,
            35.995018928000036
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 44,
      "bh": "0108",
      "mc": "U5泊位",
      "dj": "10WT",
      "ss": -14.1,
      "cd": 314,
      "ssgs_old": "QQCTU",
      "xlzs": 17,
      "xlzbh": "1#-18#",
      "kdgs": 17,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCTU",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0076572557478980698,
      "shape_Area": 9.2023257877507317e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.19379205000007,
            35.994716453000024
          ],
          [
            120.19375908600011,
            35.994972647000054
          ],
          [
            120.19731817500008,
            35.995274625000036
          ],
          [
            120.19734876400003,
            35.995018928000036
          ],
          [
            120.19379205000007,
            35.994716453000024
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 45,
      "bh": "0108",
      "mc": "70号泊位",
      "dj": "7DWT",
      "ss": -14.5,
      "cd": 212,
      "ssgs_old": "QQCT",
      "xlzs": 12,
      "xlzbh": "325#-336#",
      "kdgs": 11,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT二期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0050313748002339788,
      "shape_Area": 5.4960784389036341e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21510590700007,
            36.021458085000063
          ],
          [
            120.21699883400004,
            36.022708001000069
          ],
          [
            120.21717377100003,
            36.022533165000027
          ],
          [
            120.21528084500005,
            36.021283250000067
          ],
          [
            120.21510590700007,
            36.021458085000063
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 46,
      "bh": "0108",
      "mc": "71号泊位",
      "dj": "5DWT",
      "ss": -11.800000000000001,
      "cd": 299,
      "ssgs_old": "QQCT",
      "xlzs": 17,
      "xlzbh": "336#-352#",
      "kdgs": 15,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT二期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0066888861470900257,
      "shape_Area": 7.4956743916134785e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21286246600005,
            36.019686273000048
          ],
          [
            120.21271764200003,
            36.019581966000032
          ],
          [
            120.21258237400002,
            36.019695151000064
          ],
          [
            120.21251600100004,
            36.019750688000045
          ],
          [
            120.21268752600008,
            36.019861103000039
          ],
          [
            120.21510590700007,
            36.021458085000063
          ],
          [
            120.21528084500005,
            36.021283250000067
          ],
          [
            120.21294958800001,
            36.019743807000054
          ],
          [
            120.21286246600005,
            36.019686273000048
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 47,
      "bh": "0108",
      "mc": "69号泊位",
      "dj": "3DWT",
      "ss": -11.6,
      "cd": 219.5,
      "ssgs_old": "QQCT",
      "xlzs": 11,
      "xlzbh": "315#-325#",
      "kdgs": 11,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT二期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0050251736335994897,
      "shape_Area": 5.4856974439959274e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21888170500006,
            36.023660868000036
          ],
          [
            120.21717377100003,
            36.022533165000027
          ],
          [
            120.21699883400004,
            36.022708001000069
          ],
          [
            120.21874435000007,
            36.023860520000028
          ],
          [
            120.21889207000004,
            36.023951719000024
          ],
          [
            120.21906695200005,
            36.023776682000062
          ],
          [
            120.21891928600007,
            36.023685680000028
          ],
          [
            120.21888170500006,
            36.023660868000036
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 48,
      "bh": "0108",
      "mc": "66泊位",
      "dj": "7DWT",
      "ss": -11.5,
      "cd": 200,
      "ssgs_old": "前港公司",
      "xlzs": 6,
      "xlzbh": "294#-299#",
      "kdgs": 11,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.004641357390637979,
      "shape_Area": 5.2443078432356476e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22269497400009,
            36.026158192000025
          ],
          [
            120.22250789800012,
            36.026345174000028
          ],
          [
            120.22250922000001,
            36.026346047000061
          ],
          [
            120.22422862000008,
            36.027481102000024
          ],
          [
            120.22440904400003,
            36.027301186000045
          ],
          [
            120.22269497400009,
            36.026158192000025
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 49,
      "bh": "0108",
      "mc": "68泊位",
      "dj": "7DWT",
      "ss": -11.5,
      "cd": 211,
      "ssgs_old": "前港公司",
      "xlzs": 6,
      "xlzbh": "308#-313#",
      "kdgs": 12,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.0048706641116868996,
      "shape_Area": 5.4891333235605625e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21889207000004,
            36.023951719000024
          ],
          [
            120.21889763900003,
            36.023955492000027
          ],
          [
            120.21925774300007,
            36.024199441000064
          ],
          [
            120.22070413300003,
            36.025154364000059
          ],
          [
            120.22089435600003,
            36.024964301000068
          ],
          [
            120.21934990800003,
            36.023967151000079
          ],
          [
            120.21906695200005,
            36.023776682000062
          ],
          [
            120.21889207000004,
            36.023951719000024
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 50,
      "bh": "0108",
      "mc": "64泊位",
      "dj": "10DWT",
      "ss": -14.1,
      "cd": 265,
      "ssgs_old": "前港公司",
      "xlzs": 9,
      "xlzbh": "1#-9#",
      "kdgs": 15,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0065261645349335541,
      "shape_Area": 7.3597968991870648e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22662601100001,
            36.029063630000053
          ],
          [
            120.22684802200001,
            36.029210177000039
          ],
          [
            120.22697871100002,
            36.02912976500005
          ],
          [
            120.22699485700002,
            36.029147081000076
          ],
          [
            120.22718966100001,
            36.029027220000046
          ],
          [
            120.22717046900004,
            36.029006640000034
          ],
          [
            120.22725904800006,
            36.028952138000079
          ],
          [
            120.2272757180001,
            36.028970014000038
          ],
          [
            120.22747253800003,
            36.028848910000079
          ],
          [
            120.22745351600008,
            36.028828512000075
          ],
          [
            120.22754171100007,
            36.028774246000069
          ],
          [
            120.22755782100012,
            36.028791521000073
          ],
          [
            120.22775410700001,
            36.028670744000067
          ],
          [
            120.22773477800001,
            36.028650018000064
          ],
          [
            120.22781878900003,
            36.028598275000036
          ],
          [
            120.2278207600001,
            36.028597880000063
          ],
          [
            120.22782296900004,
            36.028597871000045
          ],
          [
            120.22782439700006,
            36.028598367000029
          ],
          [
            120.22782570600009,
            36.028599166000049
          ],
          [
            120.22784200500007,
            36.028615062000029
          ],
          [
            120.2280360200001,
            36.028492217000064
          ],
          [
            120.22801724300007,
            36.028472648000047
          ],
          [
            120.2281045950001,
            36.028417340000033
          ],
          [
            120.22812389600006,
            36.028437453000038
          ],
          [
            120.22831770800008,
            36.028314736000027
          ],
          [
            120.22829880800009,
            36.028295041000035
          ],
          [
            120.22838578400001,
            36.028239970000072
          ],
          [
            120.22840495200001,
            36.028259945000059
          ],
          [
            120.22859993200007,
            36.02813648800003
          ],
          [
            120.22858056900009,
            36.028116311000076
          ],
          [
            120.22866815400005,
            36.028060852000067
          ],
          [
            120.22868715000004,
            36.028080648000071
          ],
          [
            120.22888091200002,
            36.027957961000027
          ],
          [
            120.22886207500005,
            36.02793833100003
          ],
          [
            120.22894961800012,
            36.027882901000055
          ],
          [
            120.22896893000006,
            36.027903025000057
          ],
          [
            120.22916160900002,
            36.027781024000035
          ],
          [
            120.22914214200011,
            36.02776073800004
          ],
          [
            120.22918518300003,
            36.027733485000056
          ],
          [
            120.22899387600012,
            36.027559587000042
          ],
          [
            120.22662601100001,
            36.029063630000053
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 51,
      "bh": "0108",
      "mc": "76泊位",
      "dj": "25DWT",
      "ss": -21,
      "cd": 383,
      "ssgs_old": "前港公司",
      "xlzs": 16,
      "xlzbh": "0#-16#",
      "kdgs": 14,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0089957532047491053,
      "shape_Area": 1.3572536550095438e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.23105152300002,
            36.029316140000049
          ],
          [
            120.23119379500008,
            36.02962939400004
          ],
          [
            120.23518187000002,
            36.028425552000044
          ],
          [
            120.23505539000007,
            36.028139544000055
          ],
          [
            120.23105152300002,
            36.029316140000049
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 52,
      "bh": "0108",
      "mc": "86泊位",
      "dj": "20WT",
      "ss": -14.5,
      "cd": 229,
      "ssgs_old": "前港公司",
      "xlzs": 9,
      "xlzbh": "1#-12#",
      "kdgs": 12,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0042328756355497271,
      "shape_Area": 6.1544272199254837e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.2261389570001,
            36.03156270900007
          ],
          [
            120.22581495400004,
            36.031727905000025
          ],
          [
            120.22657376400002,
            36.032708884000044
          ],
          [
            120.22689359900005,
            36.033122136000031
          ],
          [
            120.2272025420001,
            36.032964423000067
          ],
          [
            120.2261389570001,
            36.03156270900007
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 53,
      "bh": "0108",
      "mc": "87泊位",
      "dj": "20WT",
      "ss": -17.5,
      "cd": 443,
      "ssgs_old": "前港公司",
      "xlzs": 29,
      "xlzbh": "12#-38#",
      "kdgs": 29,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0096007730713331511,
      "shape_Area": 1.5279708081113851e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.22689359900005,
            36.033122136000031
          ],
          [
            120.22961765800005,
            36.036641614000075
          ],
          [
            120.22993108800006,
            36.036481596000044
          ],
          [
            120.2272025420001,
            36.032964423000067
          ],
          [
            120.22689359900005,
            36.033122136000031
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 54,
      "bh": "0108",
      "mc": "67泊位",
      "dj": "7DWT",
      "ss": -11.5,
      "cd": 209.5,
      "ssgs_old": "前港公司",
      "xlzs": 8,
      "xlzbh": "300#-307#",
      "kdgs": 17,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.0048552525753951343,
      "shape_Area": 5.6468984906158553e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22269497400009,
            36.026158192000025
          ],
          [
            120.22089435600003,
            36.024964301000068
          ],
          [
            120.22070413300003,
            36.025154364000059
          ],
          [
            120.2207054480001,
            36.025155232000031
          ],
          [
            120.22250789800012,
            36.026345174000028
          ],
          [
            120.22269497400009,
            36.026158192000025
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 55,
      "bh": "0108",
      "mc": "46泊位",
      "dj": "3.5WT",
      "ss": -12.4,
      "cd": 220,
      "ssgs_old": "大港",
      "xlzs": 5,
      "xlzbh": "138#-141B#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0039826841382220998,
      "shape_Area": 3.7286588720467607e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32377201800011,
            36.096152287000052
          ],
          [
            120.32364579900002,
            36.096315858000025
          ],
          [
            120.32524134900007,
            36.097105139000064
          ],
          [
            120.32537013400008,
            36.096926547000066
          ],
          [
            120.32377201800011,
            36.096152287000052
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 56,
      "bh": "0108",
      "mc": "63泊位",
      "dj": "10DWT",
      "ss": -14.1,
      "cd": 298,
      "ssgs_old": "前港公司",
      "xlzs": 10,
      "xlzbh": "265#-274#",
      "kdgs": 18,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0072680889927425598,
      "shape_Area": 8.3987596973607985e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22919520700009,
            36.027747599000065
          ],
          [
            120.22922413100002,
            36.027708823000069
          ],
          [
            120.22922935300005,
            36.027705518000062
          ],
          [
            120.2292485480001,
            36.027725521000036
          ],
          [
            120.2294430610001,
            36.027602357000035
          ],
          [
            120.22942409600012,
            36.027582595000069
          ],
          [
            120.22951144000001,
            36.027527289000034
          ],
          [
            120.22953041100004,
            36.02754705600006
          ],
          [
            120.2297249070001,
            36.027423901000077
          ],
          [
            120.22970592100012,
            36.027404116000071
          ],
          [
            120.22979262700005,
            36.027349214000026
          ],
          [
            120.22981203500001,
            36.027369437000061
          ],
          [
            120.23000643100011,
            36.027246345000037
          ],
          [
            120.22998685500011,
            36.027225946000044
          ],
          [
            120.23007421300008,
            36.027170630000057
          ],
          [
            120.23009380800011,
            36.027191050000056
          ],
          [
            120.23028672900011,
            36.027068892000045
          ],
          [
            120.23026736000008,
            36.027048708000052
          ],
          [
            120.23035516900006,
            36.026993106000077
          ],
          [
            120.23037423200003,
            36.027012971000033
          ],
          [
            120.23056876100009,
            36.026889794000056
          ],
          [
            120.23054898800001,
            36.02686919000007
          ],
          [
            120.2306365820001,
            36.026813724000078
          ],
          [
            120.23065698000005,
            36.026834979000057
          ],
          [
            120.23085178200006,
            36.026711626000065
          ],
          [
            120.23083284400002,
            36.026691892000031
          ],
          [
            120.23092086700001,
            36.026636154000073
          ],
          [
            120.23094017000005,
            36.026656269000057
          ],
          [
            120.23113372400007,
            36.026533705000077
          ],
          [
            120.23111417400003,
            36.026513334000072
          ],
          [
            120.23120141300001,
            36.026458092000041
          ],
          [
            120.23122093600011,
            36.026478435000058
          ],
          [
            120.23141547300008,
            36.026355249000062
          ],
          [
            120.23139667200007,
            36.02633565800005
          ],
          [
            120.23148394700002,
            36.026280393000036
          ],
          [
            120.23150298300004,
            36.026300230000061
          ],
          [
            120.23169585700009,
            36.026178095000034
          ],
          [
            120.23167735200002,
            36.026158813000052
          ],
          [
            120.23181354300004,
            36.026072571000043
          ],
          [
            120.2318056360001,
            36.026065477000031
          ],
          [
            120.23180151100007,
            36.026075191000075
          ],
          [
            120.23160811500009,
            36.02589832600006
          ],
          [
            120.22899387600012,
            36.027559587000042
          ],
          [
            120.22919520700009,
            36.027747599000065
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 57,
      "bh": "0108",
      "mc": "65泊位",
      "dj": "12DWT",
      "ss": -14.1,
      "cd": 312.5,
      "ssgs_old": "前港公司",
      "xlzs": 12,
      "xlzbh": "282#-293#",
      "kdgs": 14,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "前港公司",
      "wlgz": "",
      "bz": "缺验收证明材料",
      "ssmt": null,
      "shape_Length": 0.0068217364204525652,
      "shape_Area": 7.0981720870727603e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22440904400003,
            36.027301186000045
          ],
          [
            120.22422862000008,
            36.027481102000024
          ],
          [
            120.22422980900001,
            36.027481886000032
          ],
          [
            120.22598655900003,
            36.028641537000055
          ],
          [
            120.22684802200001,
            36.029210177000039
          ],
          [
            120.22705119200009,
            36.029108286000053
          ],
          [
            120.22440904400003,
            36.027301186000045
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 58,
      "bh": "0108",
      "mc": "C1泊位",
      "dj": "7WT",
      "ss": -13.5,
      "cd": 250,
      "ssgs_old": "大港",
      "xlzs": 13,
      "xlzbh": "613#-625#",
      "kdgs": 12,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0053071130501627164,
      "shape_Area": 5.7508245475664849e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.30274253300001,
            36.082499425000037
          ],
          [
            120.30464355300001,
            36.083987297000078
          ],
          [
            120.30482805600002,
            36.08383798400007
          ],
          [
            120.3037852110001,
            36.083011637000027
          ],
          [
            120.30294770900002,
            36.082346692000044
          ],
          [
            120.30274253300001,
            36.082499425000037
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 59,
      "bh": "0108",
      "mc": "C2泊位",
      "dj": "7WT",
      "ss": -13.5,
      "cd": 250,
      "ssgs_old": "大港",
      "xlzs": 9,
      "xlzbh": "605#-613#",
      "kdgs": 9,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0053393209591863881,
      "shape_Area": 5.3748631639745418e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.30482805600002,
            36.08383798400007
          ],
          [
            120.30464355300001,
            36.083987297000078
          ],
          [
            120.30657636900003,
            36.085491000000047
          ],
          [
            120.30673978200002,
            36.085354402000064
          ],
          [
            120.30482805600002,
            36.08383798400007
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 60,
      "bh": "0108",
      "mc": "35泊位",
      "dj": "8000T",
      "ss": -7.9000000000000004,
      "cd": 146,
      "ssgs_old": "大港",
      "xlzs": 6,
      "xlzbh": "83#-88#",
      "kdgs": 6,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0036590268410979189,
      "shape_Area": 3.2652206952102985e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31092701200009,
            36.085899912000059
          ],
          [
            120.30931269100006,
            36.086111656000071
          ],
          [
            120.30935494500011,
            36.086316455000031
          ],
          [
            120.31096771900002,
            36.086088536000034
          ],
          [
            120.31092701200009,
            36.085899912000059
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 61,
      "bh": "0108",
      "mc": "36泊位",
      "dj": "8000T",
      "ss": -7.9000000000000004,
      "cd": 150,
      "ssgs_old": "大港",
      "xlzs": 6,
      "xlzbh": "78#-83#",
      "kdgs": 8,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.00369382266328331,
      "shape_Area": 3.1398303766020958e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31255870000007,
            36.085659023000062
          ],
          [
            120.31092701200009,
            36.085899912000059
          ],
          [
            120.31096771900002,
            36.086088536000034
          ],
          [
            120.31261208100011,
            36.085839702000044
          ],
          [
            120.31255870000007,
            36.085659023000062
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 62,
      "bh": "0108",
      "mc": "40泊位",
      "dj": "3000T",
      "ss": -6.5,
      "cd": 180,
      "ssgs_old": "大港",
      "xlzs": 7,
      "xlzbh": "78#-106#",
      "kdgs": 9,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0040198989953439462,
      "shape_Area": 3.3521105516761941e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31436849600004,
            36.08538909400005
          ],
          [
            120.31255870000007,
            36.085659023000062
          ],
          [
            120.31261208100011,
            36.085839702000044
          ],
          [
            120.31441151400008,
            36.085565383000073
          ],
          [
            120.31436849600004,
            36.08538909400005
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 63,
      "bh": "0108",
      "mc": "42泊位",
      "dj": "8000T",
      "ss": -7.2999999999999998,
      "cd": 162,
      "ssgs_old": "大港",
      "xlzs": 6,
      "xlzbh": "111#-116#",
      "kdgs": 0,
      "ggxx": "轮舶公司给折处",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0036234075593385901,
      "shape_Area": 2.9318735874532699e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31727636400001,
            36.086507314000073
          ],
          [
            120.31578046600009,
            36.085866917000033
          ],
          [
            120.31567010800006,
            36.086029667000048
          ],
          [
            120.31717612400007,
            36.08664699600007
          ],
          [
            120.31727636400001,
            36.086507314000073
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 64,
      "bh": "0108",
      "mc": "41泊位",
      "dj": "5000T",
      "ss": -7.2999999999999998,
      "cd": 120,
      "ssgs_old": "大港",
      "xlzs": 5,
      "xlzbh": "107#-111#",
      "kdgs": 0,
      "ggxx": "轮舶公司给折处",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0030802127894868549,
      "shape_Area": 2.6772196393690822e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31453738100004,
            36.085355403000051
          ],
          [
            120.31443474300011,
            36.08553856900005
          ],
          [
            120.31567010800006,
            36.086029667000048
          ],
          [
            120.31578046600009,
            36.085866917000033
          ],
          [
            120.31453738100004,
            36.085355403000051
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 65,
      "bh": "0108",
      "mc": "1泊位",
      "dj": "8000T",
      "ss": -17.399999999999999,
      "cd": 136,
      "ssgs_old": "大港",
      "xlzs": 6,
      "xlzbh": "1#-6#",
      "kdgs": 8,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0031444200210280267,
      "shape_Area": 2.7142419542790993e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31565093300003,
            36.086770020000074
          ],
          [
            120.31571371000007,
            36.086966272000041
          ],
          [
            120.31705851600009,
            36.086709059000043
          ],
          [
            120.31700644500006,
            36.086524625000038
          ],
          [
            120.31565093300003,
            36.086770020000074
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 66,
      "bh": "0108",
      "mc": "2泊位",
      "dj": "1WT",
      "ss": -8.0999999999999996,
      "cd": 180,
      "ssgs_old": "大港",
      "xlzs": 6,
      "xlzbh": "7#-12#",
      "kdgs": 8,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0043531898613897351,
      "shape_Area": 4.0867570497742203e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31565093300003,
            36.086770020000074
          ],
          [
            120.31371779500012,
            36.087136979000036
          ],
          [
            120.31378234600004,
            36.087339349000047
          ],
          [
            120.31571371000007,
            36.086966272000041
          ],
          [
            120.31565093300003,
            36.086770020000074
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 67,
      "bh": "0108",
      "mc": "3泊位",
      "dj": "1WT",
      "ss": -9,
      "cd": 212,
      "ssgs_old": "大港",
      "xlzs": 7,
      "xlzbh": "13#-19#",
      "kdgs": 7,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0048132967963375253,
      "shape_Area": 4.6037546482077297e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31371779500012,
            36.087136979000036
          ],
          [
            120.31156559100009,
            36.087568916000066
          ],
          [
            120.31162840400009,
            36.087768716000028
          ],
          [
            120.31378234600004,
            36.087339349000047
          ],
          [
            120.31371779500012,
            36.087136979000036
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 68,
      "bh": "0108",
      "mc": "4泊位",
      "dj": "2WT",
      "ss": -10.199999999999999,
      "cd": 220,
      "ssgs_old": "大港",
      "xlzs": 6,
      "xlzbh": "21#-27#",
      "kdgs": 11,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0054260817359774467,
      "shape_Area": 5.1528362715722559e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31190826400007,
            36.088391283000078
          ],
          [
            120.31187053400004,
            36.088596273000064
          ],
          [
            120.31435167300003,
            36.088951191000035
          ],
          [
            120.31439046200001,
            36.088751941000055
          ],
          [
            120.31190826400007,
            36.088391283000078
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 69,
      "bh": "0108",
      "mc": "5泊位",
      "dj": "5WT",
      "ss": -13,
      "cd": 290,
      "ssgs_old": "大港",
      "xlzs": 16,
      "xlzbh": "26#-39#",
      "kdgs": 13,
      "ggxx": "坚壁式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0068153431316997672,
      "shape_Area": 6.7616352294519613e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31753553200008,
            36.088136644000031
          ],
          [
            120.31440242300005,
            36.088763955000047
          ],
          [
            120.31447022600003,
            36.088963658000068
          ],
          [
            120.31760247400007,
            36.088341759000059
          ],
          [
            120.31753553200008,
            36.088136644000031
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 70,
      "bh": "0108",
      "mc": "11泊位",
      "dj": "1WT",
      "ss": -9,
      "cd": 160,
      "ssgs_old": "大港",
      "xlzs": 5,
      "xlzbh": "50B#-54#",
      "kdgs": 6,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.003878459266059649,
      "shape_Area": 3.5282611625070101e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31625666500008,
            36.089619344000027
          ],
          [
            120.3163128650001,
            36.089810541000077
          ],
          [
            120.31801551500007,
            36.089485077000063
          ],
          [
            120.31796074900001,
            36.089283544000068
          ],
          [
            120.31625666500008,
            36.089619344000027
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 71,
      "bh": "0108",
      "mc": "12泊位",
      "dj": "1WT",
      "ss": -9,
      "cd": 100,
      "ssgs_old": "大港",
      "xlzs": 7,
      "xlzbh": "54#-56#",
      "kdgs": 4,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0023109727312118186,
      "shape_Area": 1.9846877360088305e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31628467900009,
            36.089850922000039
          ],
          [
            120.31606796900007,
            36.089900188000058
          ],
          [
            120.31641511800001,
            36.090774977000024
          ],
          [
            120.31661529100006,
            36.09073443300008
          ],
          [
            120.31628467900009,
            36.089850922000039
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 72,
      "bh": "0108",
      "mc": "13泊位",
      "dj": "1WT",
      "ss": -8.4000000000000004,
      "cd": 160,
      "ssgs_old": "大港",
      "xlzs": 5,
      "xlzbh": "56#-60#",
      "kdgs": 6,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.003878227106383015,
      "shape_Area": 3.5212048008380338e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31851343000005,
            36.090574557000025
          ],
          [
            120.31845462500007,
            36.090382462000036
          ],
          [
            120.31675556500011,
            36.090742637000062
          ],
          [
            120.3168184540001,
            36.090939529000025
          ],
          [
            120.31851343000005,
            36.090574557000025
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 73,
      "bh": "0108",
      "mc": "14泊位",
      "dj": "8000T",
      "ss": -8.3000000000000007,
      "cd": 160,
      "ssgs_old": "大港",
      "xlzs": 5,
      "xlzbh": "60#-64#",
      "kdgs": 8,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0039226639118137121,
      "shape_Area": 3.5546986054633579e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31851343000005,
            36.090574557000025
          ],
          [
            120.32023868900001,
            36.09022751100008
          ],
          [
            120.32017543100005,
            36.09003171300003
          ],
          [
            120.31845462500007,
            36.090382462000036
          ],
          [
            120.31851343000005,
            36.090574557000025
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 74,
      "bh": "0108",
      "mc": "15泊位",
      "dj": "7000T",
      "ss": -7.9000000000000004,
      "cd": 120,
      "ssgs_old": "大港",
      "xlzs": 4,
      "xlzbh": "64#-67#",
      "kdgs": 7,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0035565490989284796,
      "shape_Area": 3.1135047412429935e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32173037500002,
            36.089731550000067
          ],
          [
            120.32017543100005,
            36.09003171300003
          ],
          [
            120.32023868900001,
            36.09022751100008
          ],
          [
            120.32178391900004,
            36.089914365000027
          ],
          [
            120.32173037500002,
            36.089731550000067
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 75,
      "bh": "0108",
      "mc": "16泊位",
      "dj": "5000T",
      "ss": -5.2000000000000002,
      "cd": 150,
      "ssgs_old": "大港",
      "xlzs": 9,
      "xlzbh": "68#-76#",
      "kdgs": 5,
      "ggxx": "该泊位存在趸船",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0034051513482371244,
      "shape_Area": 2.8073490310885559e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32322400400005,
            36.089469845000053
          ],
          [
            120.32173037500002,
            36.089731550000067
          ],
          [
            120.32178391900004,
            36.089914365000027
          ],
          [
            120.32327588300006,
            36.089644375000034
          ],
          [
            120.32322400400005,
            36.089469845000053
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 76,
      "bh": "0108",
      "mc": "25泊位",
      "dj": "7000T",
      "ss": -7.7999999999999998,
      "cd": 165,
      "ssgs_old": "大港",
      "xlzs": 5,
      "xlzbh": "72#-76#",
      "kdgs": 7,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.003845784106524391,
      "shape_Area": 3.2001066232550739e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32518370700006,
            36.092859010000041
          ],
          [
            120.32689166200009,
            36.09252076000007
          ],
          [
            120.32684615000005,
            36.092347758000074
          ],
          [
            120.32514106700012,
            36.09267413300006
          ],
          [
            120.32518370700006,
            36.092859010000041
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 77,
      "bh": "0108",
      "mc": "56泊位",
      "dj": "1WT",
      "ss": -13,
      "cd": 254,
      "ssgs_old": "大港",
      "xlzs": 14,
      "xlzbh": "701#-714#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0060794615581752547,
      "shape_Area": 5.6393186497601826e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32513514400011,
            36.092648827000062
          ],
          [
            120.32233337600007,
            36.093151410000075
          ],
          [
            120.3223915640001,
            36.09335182500007
          ],
          [
            120.32517837500006,
            36.092833517000031
          ],
          [
            120.32513514400011,
            36.092648827000062
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 78,
      "bh": "0108",
      "mc": "D4泊位",
      "dj": "10WT",
      "ss": -19.199999999999999,
      "cd": 375,
      "ssgs_old": "董矿",
      "xlzs": 13,
      "xlzbh": "30#-43#",
      "kdgs": 16,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "EAM2021029450",
      "ssgs": "董矿",
      "wlgz": "",
      "bz": "省正式文件下达后可靠泊减载25WT船舶，正在审批中",
      "ssmt": null,
      "shape_Length": 0.0074109406150201299,
      "shape_Area": 1.8378385500114475e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.78628062300004,
            35.591681506000043
          ],
          [
            119.7867790140001,
            35.591984589000049
          ],
          [
            119.78878265000003,
            35.589595336000059
          ],
          [
            119.78824538200001,
            35.589292860000057
          ],
          [
            119.7881687470001,
            35.589386033000039
          ],
          [
            119.78628062300004,
            35.591681506000043
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 79,
      "bh": "0108",
      "mc": "D3泊位",
      "dj": "25WT",
      "ss": -19.199999999999999,
      "cd": 342,
      "ssgs_old": "董矿",
      "xlzs": 15,
      "xlzbh": "15#-30#",
      "kdgs": 19,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董矿",
      "wlgz": "",
      "bz": "减载25WT",
      "ssmt": null,
      "shape_Length": 0.0088464897969909341,
      "shape_Area": 2.3217502170185311e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.78824538200001,
            35.589292860000057
          ],
          [
            119.78878265000003,
            35.589595336000059
          ],
          [
            119.79106692400001,
            35.586828524000055
          ],
          [
            119.79120541200007,
            35.586659632000078
          ],
          [
            119.79065895800011,
            35.586358328000074
          ],
          [
            119.79051754500006,
            35.586530272000061
          ],
          [
            119.78824538200001,
            35.589292860000057
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 80,
      "bh": "0108",
      "mc": "D2泊位",
      "dj": "25WT",
      "ss": -19.199999999999999,
      "cd": 372,
      "ssgs_old": "董矿",
      "xlzs": 15,
      "xlzbh": "1#-15#",
      "kdgs": 18,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董矿",
      "wlgz": "",
      "bz": "减载25WT",
      "ssmt": null,
      "shape_Length": 0.0080762022897074414,
      "shape_Area": 2.087555363668991e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.79065895800011,
            35.586358328000074
          ],
          [
            119.79120541200007,
            35.586659632000078
          ],
          [
            119.79337182200004,
            35.584017502000052
          ],
          [
            119.79282892300012,
            35.583719762000044
          ],
          [
            119.79065895800011,
            35.586358328000074
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 81,
      "bh": "0108",
      "mc": "57泊位",
      "dj": "7WT",
      "ss": -14.699999999999999,
      "cd": 283,
      "ssgs_old": "大港",
      "xlzs": 14,
      "xlzbh": "715#-728#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0062689846350996257,
      "shape_Area": 5.8210663044494812e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32220882100012,
            36.093632366000065
          ],
          [
            120.32486652600005,
            36.09488925800008
          ],
          [
            120.32497121200004,
            36.094739334000053
          ],
          [
            120.3223423820001,
            36.093456311000068
          ],
          [
            120.32220882100012,
            36.093632366000065
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 82,
      "bh": "0108",
      "mc": "45泊位",
      "dj": "2WT",
      "ss": -13,
      "cd": 210,
      "ssgs_old": "大港",
      "xlzs": 8,
      "xlzbh": "133#-137#",
      "kdgs": 8,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0043150297496322362,
      "shape_Area": 3.8937466918684493e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32537013400008,
            36.096926547000066
          ],
          [
            120.32524134900007,
            36.097105139000064
          ],
          [
            120.32700253300004,
            36.097964047000062
          ],
          [
            120.32710864700005,
            36.09781487500004
          ],
          [
            120.32537013400008,
            36.096926547000066
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 83,
      "bh": "0108",
      "mc": "58泊位",
      "dj": "7WT",
      "ss": -14.699999999999999,
      "cd": 283,
      "ssgs_old": "大港",
      "xlzs": 16,
      "xlzbh": "728#-743#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0062635229712197701,
      "shape_Area": 5.3679951932482437e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32497121200004,
            36.094739334000053
          ],
          [
            120.32486652600005,
            36.09488925800008
          ],
          [
            120.32751678500006,
            36.096175413000026
          ],
          [
            120.32762516100001,
            36.096023784000067
          ],
          [
            120.32497121200004,
            36.094739334000053
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 84,
      "bh": "0108",
      "mc": "47泊位",
      "dj": "5WT",
      "ss": -12.4,
      "cd": 227,
      "ssgs_old": "大港",
      "xlzs": 7,
      "xlzbh": "142#-147B#",
      "kdgs": 8,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0067865100515270152,
      "shape_Area": 6.6154621161726887e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32090002300004,
            36.09477104900003
          ],
          [
            120.32077791200004,
            36.094949629000041
          ],
          [
            120.32364579900002,
            36.096315858000025
          ],
          [
            120.32377201800011,
            36.096152287000052
          ],
          [
            120.32090002300004,
            36.09477104900003
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 85,
      "bh": "0108",
      "mc": "44泊位",
      "dj": "1WT",
      "ss": -8.8000000000000007,
      "cd": 220,
      "ssgs_old": "大港",
      "xlzs": 8,
      "xlzbh": "125#-132#",
      "kdgs": 12,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0042380652152491771,
      "shape_Area": 4.501514899818116e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32749321900008,
            36.096149371000024
          ],
          [
            120.3270539130001,
            36.097978359000024
          ],
          [
            120.32727816600004,
            36.098017722000066
          ],
          [
            120.32774065400008,
            36.096198471000037
          ],
          [
            120.32749321900008,
            36.096149371000024
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 86,
      "bh": "0108",
      "mc": "48泊位",
      "dj": "3WT",
      "ss": -11,
      "cd": 225,
      "ssgs_old": "大港",
      "xlzs": 11,
      "xlzbh": "148#-158#",
      "kdgs": 17,
      "ggxx": "漂浮式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0047053096848663637,
      "shape_Area": 4.6173982444744314e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31927734400006,
            36.096594004000053
          ],
          [
            120.31945548300007,
            36.096679680000079
          ],
          [
            120.32072518100006,
            36.094964900000036
          ],
          [
            120.32051103100002,
            36.094854145000056
          ],
          [
            120.31927734400006,
            36.096594004000053
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 87,
      "bh": "0108",
      "mc": "49泊位",
      "dj": "3.5WT",
      "ss": -12,
      "cd": 238,
      "ssgs_old": "大港",
      "xlzs": 7,
      "xlzbh": "159#-165#",
      "kdgs": 12,
      "ggxx": "坚壁式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0050867667778430091,
      "shape_Area": 4.6029808887041774e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.31947434100005,
            36.096739648000039
          ],
          [
            120.31934200800004,
            36.096915099000057
          ],
          [
            120.32147432200009,
            36.097902136000073
          ],
          [
            120.32157899300012,
            36.097755043000063
          ],
          [
            120.31947434100005,
            36.096739648000039
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 88,
      "bh": "0108",
      "mc": "50泊位",
      "dj": "2WT",
      "ss": -10.300000000000001,
      "cd": 198,
      "ssgs_old": "大港",
      "xlzs": 8,
      "xlzbh": "165#-172#",
      "kdgs": 16,
      "ggxx": "坚壁式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0047124520644240536,
      "shape_Area": 3.8200226538482545e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32147432200009,
            36.097902136000073
          ],
          [
            120.32342776300004,
            36.098854552000034
          ],
          [
            120.3235377530001,
            36.098716059000026
          ],
          [
            120.32157899300012,
            36.097755043000063
          ],
          [
            120.32147432200009,
            36.097902136000073
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 89,
      "bh": "0108",
      "mc": "51泊位",
      "dj": "2WT",
      "ss": -10.300000000000001,
      "cd": 201,
      "ssgs_old": "大港",
      "xlzs": 7,
      "xlzbh": "172#-178#",
      "kdgs": 28,
      "ggxx": "坚壁式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0039549087492139349,
      "shape_Area": 3.0318564002216676e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.3235377530001,
            36.098716059000026
          ],
          [
            120.32342776300004,
            36.098854552000034
          ],
          [
            120.32506246600008,
            36.099625290000063
          ],
          [
            120.32516508900005,
            36.099492875000067
          ],
          [
            120.3235377530001,
            36.098716059000026
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 90,
      "bh": "0108",
      "mc": "52泊位",
      "dj": "2WT",
      "ss": -10.300000000000001,
      "cd": 234,
      "ssgs_old": "大港",
      "xlzs": 10,
      "xlzbh": "180#-189#",
      "kdgs": 19,
      "ggxx": "坚壁式护舷",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0049541478553567306,
      "shape_Area": 4.7806614397738976e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.32510058900004,
            36.099722918000055
          ],
          [
            120.32349801000009,
            36.101311985000052
          ],
          [
            120.32365892600001,
            36.101422405000051
          ],
          [
            120.32529595000005,
            36.09985572000005
          ],
          [
            120.32510058900004,
            36.099722918000055
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 91,
      "bh": "0108",
      "mc": "6泊位",
      "dj": " ",
      "ss": -11.5,
      "cd": 147.34999999999999,
      "ssgs_old": "大港",
      "xlzs": 8,
      "xlzbh": "42#-49#",
      "kdgs": 5,
      "ggxx": "漂浮式护舷\r\n",
      "equip_code": "",
      "ssgs": "大港公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0030299664410647427,
      "shape_Area": 2.94289487230026e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.3175632120001,
            36.088143682000066
          ],
          [
            120.31798194200007,
            36.089361693000058
          ],
          [
            120.31818482300002,
            36.089319659000068
          ],
          [
            120.31781252200005,
            36.088094320000039
          ],
          [
            120.3175632120001,
            36.088143682000066
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 92,
      "bh": "0108",
      "mc": "62泊位",
      "dj": "20WT",
      "ss": -22,
      "cd": 498,
      "ssgs_old": "实华公司",
      "xlzs": 12,
      "xlzbh": "201#-212#",
      "kdgs": 2,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0074598321641118513,
      "shape_Area": 1.8491463958232915e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.24322849900011,
            36.047537011000031
          ],
          [
            120.24264141100002,
            36.047615276000045
          ],
          [
            120.24331683600008,
            36.050680592000049
          ],
          [
            120.2439018120001,
            36.050602471000047
          ],
          [
            120.24322849900011,
            36.047537011000031
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 93,
      "bh": "0108",
      "mc": "90泊位",
      "dj": "30WT",
      "ss": -24,
      "cd": 520,
      "ssgs_old": "实华公司",
      "xlzs": 10,
      "xlzbh": "301#-310#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.00742496715994045,
      "shape_Area": 1.8585674071901978e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.24288350100005,
            36.042504785000062
          ],
          [
            120.24228414700008,
            36.042510227000037
          ],
          [
            120.24239382400003,
            36.045629001000066
          ],
          [
            120.24298743400004,
            36.045614139000065
          ],
          [
            120.24288350100005,
            36.042504785000062
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 94,
      "bh": "0108",
      "mc": "92泊位",
      "dj": "1WT",
      "ss": -11.1,
      "cd": 213.80000000000001,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "44#-30#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0034941932936184863,
      "shape_Area": 3.476126546165048e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22158770100009,
            36.064803099000073
          ],
          [
            120.22180536600001,
            36.064892056000076
          ],
          [
            120.22267521500009,
            36.063662772000043
          ],
          [
            120.22246402700011,
            36.063562129000047
          ],
          [
            120.22158770100009,
            36.064803099000073
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 95,
      "bh": "0108",
      "mc": "91泊位",
      "dj": "5WT",
      "ss": -11.1,
      "cd": 213.80000000000001,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "43#-29#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0034664684141540933,
      "shape_Area": 3.2983035061331441e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.2224783910001,
            36.065213437000068
          ],
          [
            120.22336143100006,
            36.06398054400006
          ],
          [
            120.22314839900002,
            36.063884194000025
          ],
          [
            120.22228974500001,
            36.065122128000041
          ],
          [
            120.2224783910001,
            36.065213437000068
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 96,
      "bh": "0108",
      "mc": "89泊位",
      "dj": "15WT",
      "ss": -16.899999999999999,
      "cd": 388,
      "ssgs_old": "实华公司",
      "xlzs": 10,
      "xlzbh": "28#-19#",
      "kdgs": 6,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0060950458367622501,
      "shape_Area": 1.2628014435151602e-006
    },
    "geometry": {
      "rings": [
        [
          [
            120.21469658300009,
            36.070653667000045
          ],
          [
            120.21518324400006,
            36.070850291000056
          ],
          [
            120.21664497400002,
            36.068785038000044
          ],
          [
            120.21618483600002,
            36.068593451000027
          ],
          [
            120.21469658300009,
            36.070653667000045
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 97,
      "bh": "0108",
      "mc": "84泊位",
      "dj": "7.5WT",
      "ss": -14.199999999999999,
      "cd": 319,
      "ssgs_old": "实华公司",
      "xlzs": 15,
      "xlzbh": "18#-4#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0051787265947773184,
      "shape_Area": 8.5111298422027068e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21833844200012,
            36.065893593000055
          ],
          [
            120.21799560600004,
            36.065724178000039
          ],
          [
            120.21671093500004,
            36.067509130000076
          ],
          [
            120.21707279800012,
            36.067686109000078
          ],
          [
            120.21833844200012,
            36.065893593000055
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 98,
      "bh": "0108",
      "mc": "88泊位",
      "dj": "1.5WT",
      "ss": -9.8000000000000007,
      "cd": 201.90000000000001,
      "ssgs_old": "实华公司",
      "xlzs": 3,
      "xlzbh": "3#-1#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0027823293173270731,
      "shape_Area": 2.4776648492349313e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21911131800005,
            36.064171070000043
          ],
          [
            120.21842987000002,
            36.065134543000056
          ],
          [
            120.21862926500012,
            36.06522093600006
          ],
          [
            120.21930316200007,
            36.064260559000047
          ],
          [
            120.21911131800005,
            36.064171070000043
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 99,
      "bh": "0108",
      "mc": "60泊位",
      "dj": "2WT",
      "ss": -10.5,
      "cd": 314,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "220#-227#",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0040081009867238655,
      "shape_Area": 4.509008313751962e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22388512700002,
            36.068841515000031
          ],
          [
            120.22411830200008,
            36.068954287000054
          ],
          [
            120.22512693600004,
            36.067536784000026
          ],
          [
            120.22489093500008,
            36.067416305000052
          ],
          [
            120.22388512700002,
            36.068841515000031
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 100,
      "bh": "0108",
      "mc": "61泊位",
      "dj": "5WT",
      "ss": -12.5,
      "cd": 314,
      "ssgs_old": "实华公司",
      "xlzs": 8,
      "xlzbh": "228#-233#",
      "kdgs": 4,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0051725857829987027,
      "shape_Area": 7.5098468276737755e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.22579377400007,
            36.067572077000079
          ],
          [
            120.22548763800012,
            36.067425046000039
          ],
          [
            120.22419103600009,
            36.069260082000028
          ],
          [
            120.22449536400006,
            36.069407237000064
          ],
          [
            120.22579377400007,
            36.067572077000079
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 101,
      "bh": "0108",
      "mc": "93泊位",
      "dj": "3000T",
      "ss": -5.5,
      "cd": 198,
      "ssgs_old": "实华公司",
      "xlzs": 9,
      "xlzbh": "234#-242#",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "实华公司黄岛库区",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0038769345417660568,
      "shape_Area": 3.4716414108181436e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.2284225840001,
            36.063157699000044
          ],
          [
            120.22671831300011,
            36.063486609000051
          ],
          [
            120.22676303600008,
            36.063680465000061
          ],
          [
            120.22847310700001,
            36.063352224000027
          ],
          [
            120.2284225840001,
            36.063157699000044
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 102,
      "bh": "0108",
      "mc": "D25泊位",
      "dj": "2WT",
      "ss": -14.300000000000001,
      "cd": 225,
      "ssgs_old": "液体化工码头有限公司",
      "xlzs": 10,
      "xlzbh": "16＃－25＃",
      "kdgs": 15,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "液体化工码头有限公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0051730729671777258,
      "shape_Area": 8.616133340198369e-007
    },
    "geometry": {
      "rings": [
        [
          [
            119.77457122600003,
            35.584738057000038
          ],
          [
            119.7743322770001,
            35.585068696000064
          ],
          [
            119.77624084400009,
            35.58611680000007
          ],
          [
            119.7764876220001,
            35.585816436000073
          ],
          [
            119.77457122600003,
            35.584738057000038
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 103,
      "bh": "0108",
      "mc": "1号泊位",
      "dj": "1WT",
      "ss": -9.4000000000000004,
      "cd": 167,
      "ssgs_old": "红星物流公司",
      "xlzs": 0,
      "xlzbh": " ",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "红星物流",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0010617513751461566,
      "shape_Area": 4.7713291911422137e-008
    },
    "geometry": {
      "rings": [
        [
          [
            120.21195687700003,
            36.065055200000074
          ],
          [
            120.21184465700003,
            36.065087496000046
          ],
          [
            120.21201424700007,
            36.065464899000062
          ],
          [
            120.21212614700005,
            36.06543436000004
          ],
          [
            120.21195687700003,
            36.065055200000074
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 104,
      "bh": "0108",
      "mc": "2号泊位",
      "dj": "5WT",
      "ss": -14,
      "cd": 280,
      "ssgs_old": "红星物流公司",
      "xlzs": 0,
      "xlzbh": " ",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "红星物流",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0019428211033303343,
      "shape_Area": 1.1220175645024779e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.21274764000009,
            36.066797153000039
          ],
          [
            120.21261499400009,
            36.066832570000031
          ],
          [
            120.21296155400012,
            36.067593044000034
          ],
          [
            120.21309184300003,
            36.06755770400008
          ],
          [
            120.21274764000009,
            36.066797153000039
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 105,
      "bh": "0108",
      "mc": "液体化工品泊位",
      "dj": "5WT",
      "ss": -14.300000000000001,
      "cd": 230,
      "ssgs_old": "董家口液体化码头公司",
      "xlzs": 0,
      "xlzbh": " ",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "董家口液体化码头公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0051622440140180557,
      "shape_Area": 8.0646140041306632e-008
    },
    "geometry": {
      "rings": [
        [
          [
            119.77429442500011,
            35.585011945000076
          ],
          [
            119.77206039800001,
            35.583786185000065
          ],
          [
            119.77203911400011,
            35.583811403000027
          ],
          [
            119.77427512300005,
            35.585036639000066
          ],
          [
            119.77429442500011,
            35.585011945000076
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 106,
      "bh": "0108",
      "mc": "液体化工品泊位",
      "dj": "2WT",
      "ss": -14.300000000000001,
      "cd": 227,
      "ssgs_old": "董家口液体化码头公司",
      "xlzs": 0,
      "xlzbh": " ",
      "kdgs": 0,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "董家口液体化码头公司",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0045522759910059558,
      "shape_Area": 6.8051084645413952e-008
    },
    "geometry": {
      "rings": [
        [
          [
            119.77429442500011,
            35.585011945000076
          ],
          [
            119.77427512300005,
            35.585036639000066
          ],
          [
            119.77624323400005,
            35.58611501200005
          ],
          [
            119.77626373200007,
            35.586092395000037
          ],
          [
            119.77429442500011,
            35.585011945000076
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.5,
    "attributes": {
      "OBJECTID": 107,
      "bh": "0108",
      "mc": "D22泊位",
      "dj": "30WT",
      "ss": -27,
      "cd": 455,
      "ssgs_old": "摩科瑞",
      "xlzs": 12,
      "xlzbh": "01#-18#",
      "kdgs": 4,
      "ggxx": " ",
      "equip_code": "",
      "ssgs": "摩科瑞",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0080801634121200391,
      "shape_Area": 2.0398815764998661e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.77460259500003,
            35.568093375000046
          ],
          [
            119.77764837000007,
            35.569684727000038
          ],
          [
            119.77802042700011,
            35.569209374000025
          ],
          [
            119.7749746610001,
            35.567618031000052
          ],
          [
            119.77460259500003,
            35.568093375000046
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 108,
      "bh": "0108",
      "mc": "79号泊位",
      "dj": "15DWT",
      "ss": -17.5,
      "cd": 377,
      "ssgs_old": "QQCT",
      "xlzs": 18,
      "xlzbh": "438#-455#",
      "kdgs": 18,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0080482239173769125,
      "shape_Area": 9.4217714546301092e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.20577022700002,
            36.008175928000071
          ],
          [
            120.20834509500003,
            36.010500384000068
          ],
          [
            120.20855121300008,
            36.010349658000052
          ],
          [
            120.20597634400008,
            36.00802520700006
          ],
          [
            120.20575374000009,
            36.007824242000027
          ],
          [
            120.20554762300003,
            36.007974964000027
          ],
          [
            120.20577022700002,
            36.008175928000071
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 109,
      "bh": "0108",
      "mc": "81号泊位",
      "dj": "20WT",
      "ss": -17.5,
      "cd": 348,
      "ssgs_old": "QQCT",
      "xlzs": 17,
      "xlzbh": "472#-488#",
      "kdgs": 17,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "QQCT三期",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0074681110286575472,
      "shape_Area": 8.69653793925551e-007
    },
    "geometry": {
      "rings": [
        [
          [
            120.20087320200003,
            36.003754617000027
          ],
          [
            120.20323260900011,
            36.005884911000066
          ],
          [
            120.20343872500007,
            36.00573419300008
          ],
          [
            120.20107931500002,
            36.003603903000055
          ],
          [
            120.20085673700009,
            36.00340293000005
          ],
          [
            120.20065062200001,
            36.003553643000032
          ],
          [
            120.20087320200003,
            36.003754617000027
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 110,
      "bh": "0108",
      "mc": "D1泊位",
      "dj": "40WT",
      "ss": -25,
      "cd": 510,
      "ssgs_old": "董矿",
      "xlzs": 15,
      "xlzbh": "1#-15#",
      "kdgs": 15,
      "ggxx": "矩形橡胶护舷",
      "equip_code": "",
      "ssgs": "董矿",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0083443931757310533,
      "shape_Area": 2.2945363774167486e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.78915608700004,
            35.575291847000074
          ],
          [
            119.78873752300001,
            35.575808702000074
          ],
          [
            119.79181235600004,
            35.577490627000032
          ],
          [
            119.79223438600002,
            35.576975662000052
          ],
          [
            119.78915608700004,
            35.575291847000074
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 111,
      "bh": "0108",
      "mc": "D5泊位",
      "dj": "7WT",
      "ss": -17.199999999999999,
      "cd": 242,
      "ssgs_old": "董矿",
      "xlzs": 10,
      "xlzbh": "43#-53#",
      "kdgs": 14,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "董矿",
      "wlgz": "",
      "bz": "省正式文件下达后可靠泊减载15WT船舶，正在审批中\r\n省正式文件下达后可靠泊减载15万吨级船舶，正在审批中\r\n省正式文件下达后可靠泊减载15万吨级船",
      "ssmt": null,
      "shape_Length": 0.0062309651721178406,
      "shape_Area": 1.4079978902168412e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.7867790140001,
            35.591984589000049
          ],
          [
            119.78628062300004,
            35.591681506000043
          ],
          [
            119.78583670900002,
            35.592221167000048
          ],
          [
            119.78465162800001,
            35.593661817000054
          ],
          [
            119.78512110200006,
            35.593919367000069
          ],
          [
            119.7867790140001,
            35.591984589000049
          ]
        ]
      ]
    }
  },
  {
    rotation: -0.5,
    "attributes": {
      "OBJECTID": 112,
      "bh": "0108",
      "mc": "HW2泊位",
      "dj": "2DWT",
      "ss": -12.5,
      "cd": 210,
      "ssgs_old": "海湾港务",
      "xlzs": 10,
      "xlzbh": "HW_XCZ_12-HW_XCZ_21",
      "kdgs": 23,
      "ggxx": "超级鼓型橡胶",
      "equip_code": "",
      "ssgs": "海湾港务",
      "wlgz": "",
      "bz": " ",
      "ssmt": null,
      "shape_Length": 0.0056618713570796564,
      "shape_Area": 1.0934391539112597e-006
    },
    "geometry": {
      "rings": [
        [
          [
            119.7699622450001,
            35.582671445000074
          ],
          [
            119.77204172100005,
            35.583810819000064
          ],
          [
            119.77232896500004,
            35.583476309000048
          ],
          [
            119.77030716100001,
            35.582296925000037
          ],
          [
            119.7699622450001,
            35.582671445000074
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 113,
      "bh": "0108",
      "mc": "9#泊位",
      "dj": "3000",
      "ss": -11,
      "cd": 100,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 5,
      "xlzbh": "0901-0905",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "09",
      "bz": "20000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0033584443293008422,
      "shape_Area": 4.1117764194972365e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19924828500007,
            37.449782477000042
          ],
          [
            122.19900546300005,
            37.449971099000038
          ],
          [
            122.20006708900007,
            37.450839768000037
          ],
          [
            122.2003092110001,
            37.450651685000025
          ],
          [
            122.20030993600005,
            37.450651166000057
          ],
          [
            122.19924828500007,
            37.449782477000042
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 114,
      "bh": "0108",
      "mc": "10#泊位",
      "dj": "10000",
      "ss": -11,
      "cd": 100,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 7,
      "xlzbh": "1006-1012",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "10",
      "bz": "20000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0033612418337496904,
      "shape_Area": 4.1159577113462225e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19924828500007,
            37.449782477000042
          ],
          [
            122.19818569600011,
            37.448912989000064
          ],
          [
            122.19794267800012,
            37.449101449000068
          ],
          [
            122.19900546300005,
            37.449971099000038
          ],
          [
            122.19924828500007,
            37.449782477000042
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 115,
      "bh": "0108",
      "mc": "13#泊位",
      "dj": "50000",
      "ss": -14.9,
      "cd": 280,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 17,
      "xlzbh": "1301-1316",
      "kdgs": 16,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "13",
      "bz": "50000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0067985131537411057,
      "shape_Area": 9.1778526617428925e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19794267800012,
            37.449101449000068
          ],
          [
            122.19818569600011,
            37.448912989000064
          ],
          [
            122.19794931200011,
            37.448719243000028
          ],
          [
            122.19569732800005,
            37.450465607000069
          ],
          [
            122.1955060790001,
            37.45061391400003
          ],
          [
            122.19573761600009,
            37.450809544000037
          ],
          [
            122.19794079400003,
            37.449101017000032
          ],
          [
            122.19794198200009,
            37.449101989000042
          ],
          [
            122.19794267800012,
            37.449101449000068
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 116,
      "bh": "0108",
      "mc": "14#泊位",
      "dj": "50000",
      "ss": -14.9,
      "cd": 240,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 13,
      "xlzbh": "1417-1429",
      "kdgs": 13,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "14",
      "bz": "50000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0058273945657495796,
      "shape_Area": 7.7382477035673912e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19573761600009,
            37.450809544000037
          ],
          [
            122.1955060790001,
            37.45061391400003
          ],
          [
            122.1934416150001,
            37.452214733000062
          ],
          [
            122.19367681000006,
            37.452407519000076
          ],
          [
            122.1957369050001,
            37.450810095000065
          ],
          [
            122.19573761600009,
            37.450809544000037
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 117,
      "bh": "0108",
      "mc": "15#泊位",
      "dj": "70000",
      "ss": -16.5,
      "cd": 315,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 17,
      "xlzbh": "1530-1546",
      "kdgs": 16,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "15",
      "bz": "70000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0063080132111712119,
      "shape_Area": 8.4492075663966876e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19367681000006,
            37.452407519000076
          ],
          [
            122.1934416150001,
            37.452214733000062
          ],
          [
            122.19118941600004,
            37.453961009000068
          ],
          [
            122.19142461500007,
            37.454153803000054
          ],
          [
            122.19367611600001,
            37.452408057000071
          ],
          [
            122.19367681000006,
            37.452407519000076
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 118,
      "bh": "0108",
      "mc": "19#泊位",
      "dj": "50000",
      "ss": -16.5,
      "cd": 300,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 19,
      "xlzbh": "1646-1664",
      "kdgs": 16,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "19",
      "bz": "100000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0067254260207019675,
      "shape_Area": 9.1512518743447224e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19118941600004,
            37.453961009000068
          ],
          [
            122.18882230300005,
            37.452029234000065
          ],
          [
            122.18857978200003,
            37.452218105000043
          ],
          [
            122.19094570800007,
            37.454148917000055
          ],
          [
            122.19118754200008,
            37.453960580000057
          ],
          [
            122.1911887230001,
            37.453961548000052
          ],
          [
            122.19118941600004,
            37.453961009000068
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 119,
      "bh": "0108",
      "mc": "客3泊位",
      "dj": "30000",
      "ss": -9,
      "cd": 300,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 12,
      "xlzbh": "K401-K411",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "K3",
      "bz": "20000DWT",
      "ssmt": "威海港滚装码头",
      "shape_Length": 0.0054447439952702448,
      "shape_Area": 7.2206577566715945e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.18514525400008,
            37.435822182000038
          ],
          [
            122.1849078570001,
            37.43562763400007
          ],
          [
            122.18300103100012,
            37.437108160000037
          ],
          [
            122.18323441700011,
            37.437304763000043
          ],
          [
            122.18514525400008,
            37.435822182000038
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 120,
      "bh": "0108",
      "mc": "17#泊位",
      "dj": "20000",
      "ss": -14.300000000000001,
      "cd": 217,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 11,
      "xlzbh": "1880-1990",
      "kdgs": 11,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "17",
      "bz": "50000DWT",
      "ssmt": "威海港集装箱码头",
      "shape_Length": 0.0050063929510920507,
      "shape_Area": 6.5784175293996371e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19293812600006,
            37.448836027000027
          ],
          [
            122.19270358500012,
            37.448638557000038
          ],
          [
            122.19264642200005,
            37.448682944000041
          ],
          [
            122.19254631300009,
            37.448760674000027
          ],
          [
            122.19223106900006,
            37.449005429000067
          ],
          [
            122.19149977400002,
            37.44957322700003
          ],
          [
            122.19096854800011,
            37.449985681000044
          ],
          [
            122.1912019020001,
            37.450183104000075
          ],
          [
            122.19173723200004,
            37.449767759000054
          ],
          [
            122.19247145200006,
            37.449198103000072
          ],
          [
            122.19280166500005,
            37.448941906000073
          ],
          [
            122.19287803000009,
            37.448882651000076
          ],
          [
            122.19293812600006,
            37.448836027000027
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 121,
      "bh": "0108",
      "mc": "11#泊位",
      "dj": "20000",
      "ss": -11.800000000000001,
      "cd": 225,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 10,
      "xlzbh": "1101-1110",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "11",
      "bz": "20000DWT",
      "ssmt": "威海港集装箱码头",
      "shape_Length": 0.0046938677721884842,
      "shape_Area": 6.1063914431171123e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.1944135980001,
            37.447310776000052
          ],
          [
            122.19283532500003,
            37.44601851200008
          ],
          [
            122.19259266400002,
            37.446206902000029
          ],
          [
            122.19417117900002,
            37.447499012000037
          ],
          [
            122.1944135980001,
            37.447310776000052
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 122,
      "bh": "0108",
      "mc": "12#泊位",
      "dj": "20000",
      "ss": -11,
      "cd": 200,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 9,
      "xlzbh": "1111-1219",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "12",
      "bz": "20000DWT",
      "ssmt": "威海港集装箱码头",
      "shape_Length": 0.0046944217287130628,
      "shape_Area": 6.1119588974848499e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.19283532500003,
            37.44601851200008
          ],
          [
            122.19125705900001,
            37.444726187000072
          ],
          [
            122.19101420900006,
            37.444914771000072
          ],
          [
            122.19259266400002,
            37.446206902000029
          ],
          [
            122.19283532500003,
            37.44601851200008
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 123,
      "bh": "0108",
      "mc": "客4泊位",
      "dj": "20000",
      "ss": -9,
      "cd": 200,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 10,
      "xlzbh": "K412-K421",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "K4",
      "bz": "30000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0049056900449008806,
      "shape_Area": 6.4171443850879427e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.18319265700006,
            37.437337873000047
          ],
          [
            122.18295525800011,
            37.437143322000054
          ],
          [
            122.18126238700006,
            37.438457651000078
          ],
          [
            122.18149316100005,
            37.438656402000049
          ],
          [
            122.18319265700006,
            37.437337873000047
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 124,
      "bh": "0108",
      "mc": "客5泊位",
      "dj": "30000",
      "ss": -9,
      "cd": 300,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 13,
      "xlzbh": "K301-K313",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "K5",
      "bz": "30000DWT",
      "ssmt": "威海港滚装码头",
      "shape_Length": 0.0054270369981519184,
      "shape_Area": 7.2204451752003201e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.18543312000008,
            37.434809743000073
          ],
          [
            122.18356487700009,
            37.433298314000069
          ],
          [
            122.18331976200011,
            37.433485609000059
          ],
          [
            122.18519060000006,
            37.435000233000039
          ],
          [
            122.18543312000008,
            37.434809743000073
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 125,
      "bh": "0108",
      "mc": "客2泊位",
      "dj": "30000",
      "ss": -9,
      "cd": 240,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 12,
      "xlzbh": "K202-K213",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "K2",
      "bz": "30000DWT",
      "ssmt": "客运码头",
      "shape_Length": 0.0047288506764172605,
      "shape_Area": 6.1182709604431819e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.18116539200003,
            37.434348186000079
          ],
          [
            122.18278861700003,
            37.433089678000044
          ],
          [
            122.18278984300002,
            37.433090594000078
          ],
          [
            122.18279049900002,
            37.43309008600005
          ],
          [
            122.18255319900004,
            37.432895463000079
          ],
          [
            122.18092578400001,
            37.434158124000078
          ],
          [
            122.18116539200003,
            37.434348186000079
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 126,
      "bh": "0108",
      "mc": "客1泊位",
      "dj": "30000",
      "ss": -9,
      "cd": 240,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 12,
      "xlzbh": "K113-K124",
      "kdgs": null,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "K1",
      "bz": "30000DWT",
      "ssmt": "客运码头",
      "shape_Length": 0.0047320875626852329,
      "shape_Area": 6.1541981192433682e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.18234141400001,
            37.43271855200004
          ],
          [
            122.18210411600012,
            37.43252392800008
          ],
          [
            122.18047670100009,
            37.433786583000028
          ],
          [
            122.18071408300011,
            37.433980151000071
          ],
          [
            122.18234141400001,
            37.43271855200004
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 127,
      "bh": "0108",
      "mc": "18#泊位",
      "dj": "20000",
      "ss": -14.300000000000001,
      "cd": 218,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 9,
      "xlzbh": "1891-1899",
      "kdgs": 8,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "18",
      "bz": "50000DWT",
      "ssmt": "威海港集装箱码头",
      "shape_Length": 0.0049500720937501134,
      "shape_Area": 6.5064623612261847e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.1944135980001,
            37.447310776000052
          ],
          [
            122.19417117900002,
            37.447499012000037
          ],
          [
            122.19270358500012,
            37.448638557000038
          ],
          [
            122.19293812600006,
            37.448836027000027
          ],
          [
            122.19465260700008,
            37.44750573400006
          ],
          [
            122.1944135980001,
            37.447310776000052
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 128,
      "bh": "0108",
      "mc": "16#泊位",
      "dj": "50000",
      "ss": -14.300000000000001,
      "cd": 285,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": 18,
      "xlzbh": "1764-1781",
      "kdgs": 15,
      "ggxx": "",
      "equip_code": "",
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "16",
      "bz": "50000DWT",
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0066396765845266499,
      "shape_Area": 8.997632086349487e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.1912019020001,
            37.450183104000075
          ],
          [
            122.19096854800011,
            37.449985681000044
          ],
          [
            122.19078688200011,
            37.450126727000054
          ],
          [
            122.19054886400011,
            37.450311523000039
          ],
          [
            122.18858578300001,
            37.451835593000055
          ],
          [
            122.18882230300005,
            37.452029234000065
          ],
          [
            122.19078356500006,
            37.450507665000032
          ],
          [
            122.19103621700003,
            37.45031165100005
          ],
          [
            122.1912019020001,
            37.450183104000075
          ]
        ]
      ]
    }
  },
  {
    "attributes": {
      "OBJECTID": 129,
      "bh": "0108",
      "mc": "8#泊位",
      "dj": "",
      "ss": null,
      "cd": null,
      "ssgs_old": "山东港口威海港有限公司",
      "xlzs": null,
      "xlzbh": null,
      "kdgs": null,
      "ggxx": null,
      "equip_code": null,
      "ssgs": "山东港口威海港有限公司",
      "wlgz": "08",
      "bz": null,
      "ssmt": "威海港散杂货码头",
      "shape_Length": 0.0019154184152570337,
      "shape_Area": 1.9097350679258989e-007
    },
    "geometry": {
      "rings": [
        [
          [
            122.20065067500002,
            37.450730583000052
          ],
          [
            122.20093264100001,
            37.450130959000035
          ],
          [
            122.20093763800003,
            37.450118586000031
          ],
          [
            122.20089515900008,
            37.450100083000052
          ],
          [
            122.20068279800012,
            37.449998899000036
          ],
          [
            122.20039369300002,
            37.450605661000054
          ],
          [
            122.2006060540001,
            37.45070684500007
          ],
          [
            122.20065067500002,
            37.450730583000052
          ]
        ]
      ]
    }
  }
]

